import { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from "react";
import { TopBar } from "../../shared/topBar/TopBar";
import { UrlPath } from "../../../config/routeConfig";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { useDispatch, useSelector } from "react-redux";
import { useFetcher, useNavigate, useParams } from "react-router-dom";
import {
  getPortFolioCashAction,
  getPortFolioCreditFacilityAction,
  getPortFolioCurrencyAction,
  getPortFolioDetailAction,
  getPortFolioDiscretionaryStatusAction,
  getPortFolioExpenseAction,
  getPortFolioListAction,
  getPortFolioManagerAction,
  getPortFolioTaxStatusAction,
  getPortFolioTypeAction,
} from "../../actions/portfolioAction";
import { getTreeofFamilyCSAction, getFamilyAction, getCSMappingsAction } from "../../actions/portfolioAttributionAction";
import { AgGridReact } from "ag-grid-react";
import { toast, ToastContainer } from "react-toastify";
import { SBAMultiSelect, SBAComboBox, SBADropDown } from "../../UiComponents/SBADropDown";
import { DateRangePicker } from "rsuite";
import { useMemo } from "react";
import { TreeView } from '@progress/kendo-react-treeview';
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { sbaAxios } from "../../utils/sbaAxios";
import {
  getLinkedPortfolioAPI,
  getPortfolioAttributionGridData,
  getPortfolioAttributionLegacyData,
  getPortfolioAttributionUIData,
  getPortfoliosByFamily,
  getTreeofFamilyClientStatements,
  getPortfolioAttributionViews,
  exportTimeSeriesAPI,
  getEnumerations,
  deleteView,
  insertNewAttrAPI,
  UpdateAttributionCustomViewsAPI,
  renameView,
  getPortfolioByClientStmt,
  getValuationStatus,
  getPortfolioCustodiansAccounts,
  getReportClassificationsAPI,
  getCSAccordion,
  DownloadDocument
} from "../../../config/apiConfig";
import { SBTreeView } from "../../UiComponents/SBTreeView";
import moment from "moment/moment";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { SBDateRangePicker } from "../../UiComponents/SBDateRangePicker";
import { useRef } from "react";
import { exportToExcelUsingRef } from "../../utils/excelExporter";
import { SBNotify } from "../../utils/sbNotify";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import "../../../App.css";
import AttributionData from './Attribution.json';
import * as XLSX from 'xlsx';
import { replaceInvalidDateByNull } from "@mui/x-date-pickers/internals";

export const NewPortfolio = {
  PortfolioId: 0,
  PortfolioName: "",
  Abbreviation: "",
  LinkedAssetId: 0,
  LinkedAssetName: "",
  Description: "",
  PortfolioTypeId: 0,
  PortfolioTypeName: "",
  DefaultCurrencyId: 0,
  DefaultCurrencyName: "",
  DefaultCashId: 0,
  DefaultCashAccountName: "",
  DefaultExpenseId: 0,
  DefaultExpenseAccountName: "",
  CreditFacilityAccountId: 0,
  DefaultCreditFacilityAccountName: "",
  PortfolioManagerId: 0,
  PortfolioManagerName: "",
  TaxStatusId: 0,
  TaxStatusName: "",
  DiscretionaryStatusId: 0,
  DiscretionaryStatusName: "",
  IsQualifiedInvestor: false,
  IsPartnership: false,
  BillingExclusion: false,
  CustodyStatus: false,
  InternalEmployee: false,
  CharitableStatus: false,
  PPLI: false,
  Notes: "",
  CloseDate: null,
  StartDate: "",
  CreatedBy: 0,
  CreatedByName: "",
  TaxEntityId: null,
  TaxEntityName: "",
  FamilyId: null,
  FamilyName: "",
};
const attributionColumns = [
  {
    "EnhancedType": 0,
    "FriendlyName": "BMV",
    "KeyName": "BMV",
    "CoreValue": null,
    "Value": null,
    "Annualized": false,
    "SortOrder": 0,
    "ListType": "S",
    "Format": "currency"
  },
  {
    "EnhancedType": 0,
    "FriendlyName": "EMV",
    "KeyName": "EMV",
    "CoreValue": null,
    "Value": null,
    "Annualized": false,
    "SortOrder": 1,
    "ListType": "S",
    "Format": "currency"
  },
  {
    "EnhancedType": -1,
    "FriendlyName": "End %",
    "KeyName": "End%",
    "CoreValue": null,
    "Value": null,
    "Annualized": false,
    "SortOrder": 2,
    "ListType": "S",
    "Format": "percentage"
  },
  {
    "EnhancedType": 6,
    "FriendlyName": "MTD TWR",
    "KeyName": "MTD",
    "CoreValue": null,
    "Value": null,
    "Annualized": false,
    "SortOrder": 3,
    "ListType": "S",
    "Format": "percentage"
  },
  {
    "EnhancedType": 7,
    "FriendlyName": "QTD TWR",
    "KeyName": "QTD",
    "CoreValue": 1,
    "Value": null,
    "Annualized": false,
    "SortOrder": 4,
    "ListType": "S",
    "Format": "percentage"
  },
  {
    "EnhancedType": 0,
    "FriendlyName": "YTD TWR",
    "KeyName": "CompoundRORDaily",
    "CoreValue": null,
    "Value": null,
    "Annualized": false,
    "SortOrder": 5,
    "ListType": "S",
    "Format": "percentage"
  },
  {
    "EnhancedType": 2,
    "FriendlyName": "TWR (Last 3 Years)",
    "KeyName": "CompoundRORDaily",
    "CoreValue": 3,
    "Value": 3,
    "Annualized": false,
    "SortOrder": 6,
    "ListType": "S",
    "Format": "percentage"
  },
  {
    "EnhancedType": 2,
    "FriendlyName": "TWR (Last 5 Years)",
    "KeyName": "CompoundRORDaily",
    "CoreValue": 5,
    "Value": 5,
    "Annualized": false,
    "SortOrder": 7,
    "ListType": "S",
    "Format": "percentage"
  },
  {
    "EnhancedType": 8,
    "FriendlyName": "ITD TWR (A)",
    "KeyName": "ITD",
    "CoreValue": null,
    "Value": null,
    "Annualized": true,
    "SortOrder": 8,
    "ListType": "S",
    "Format": "percentage"
  },
  {
    "EnhancedType": -1,
    "FriendlyName": "ITD IRR (A)",
    "KeyName": "IRR",
    "CoreValue": null,
    "Value": null,
    "Annualized": true,
    "SortOrder": 9,
    "ListType": "S",
    "Format": "percentage"
  },
  {
    "EnhancedType": -1,
    "FriendlyName": "Inception Date",
    "KeyName": "InceptionDate",
    "CoreValue": null,
    "Value": null,
    "Annualized": false,
    "SortOrder": 10,
    "ListType": "S",
    "Format": "date"
  }
];
export const PortfolioAttribution = ({ }) => {
  const currentDate = new Date();
  const endOfPreviousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
  const beginningOfYear =  endOfPreviousMonth.getFullYear()<  currentDate.getFullYear() ? new Date(endOfPreviousMonth.getFullYear(), 0, 1) : new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

  const params = useParams();
  const dispatch = useDispatch();
  const history = useNavigate();
  const portfolioId = params.PortfolioId;
  const Gstate = useSelector((state) => state);
  const Stateportfolio = Gstate.portfolio.portfolio;
  const portfolioList = Gstate.portfolio.portfolioList;
  const gridRef = useRef();

  const isEditable = useSelector((state) => state.authorizationData.isEditable);
  const [isEdit, setIsEdit] = useState(isEditable);
  const [dateRange, setDateRange] = useState({ start: beginningOfYear, end: endOfPreviousMonth });
  const [isHideZero, setIsHideZero] = useState(true);
  const [isHideBench, setIsHideBench] = useState(false);
  const [isHideFee, setIsHideFee] = useState(false);

  const [familyList, setFamilyList] = useState([]);
  const [familyListBackUP, setFamilyListBackUP] = useState([]);
  const [selectedPortfolio, setSelectedPortfolio] = useState([]);
  const [gridData, setGridData] = useState([]);

  const [portfolio, setPortfolio] = useState(selectedPortfolio.filter(item => item.marked));
  const [clientStatements, setClientStatements] = useState([]);
  const [colDef, setColDef] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [showDocumentDrawer, setShowDocumentDrawer] = useState(false);
  const [managerStatementDocumentList, setManagerStatementDocumentList] = useState([]);
  const [showView, setshowView] = useState(false);
  const [Classificationdata, setClassificationdata] = useState([]);
  const [selectedReportClassification, setselectedReportClassification] = useState(null);
  const downloadDocument = (documentId) => {
    const urlBuild = DownloadDocument + btoa(documentId.toString());
    sbaAxios({ url: urlBuild }).then(response => {
        window.open(urlBuild);
    })
};
  const reportdownload=(DocId)=>
        {
            if(DocId==0)
            {
                SBNotify({ Msg: "Document Not Mapped.", type: "error" });
            }
            else

            {
                downloadDocument(DocId);
            }
           
        }
  useEffect(()=>{
    console.log(managerStatementDocumentList);
  },[managerStatementDocumentList]);

  const GetReportClassificationsAPI = () => {
    sbaAxios({ url: getReportClassificationsAPI }).then(res => {
        setClassificationdata(res);
        setselectedReportClassification(res[0]);

    }).catch(e => {
        console.log(e, 'Error Loading the Classification Data');
        setClassificationdata([]);
    })
};
  useEffect(() => {
    setPortfolio(selectedPortfolio.filter(item => item.marked))
  }, [selectedPortfolio])
  // const calendarSettings = {
  //   bottomView: "year",
  //   topView: "decade",
  //   views: 2,
  // };
  useEffect(() => {
    setIsEdit(isEditable);
  }, [isEditable]);

  const removeDrawerTabIndex = () => {
    const drawers = document.getElementsByClassName('rs-drawer-wrapper');
    Array.from(drawers).forEach(drawer => {
      drawer.removeAttribute('tabIndex');
    });
  };
  removeDrawerTabIndex();

  const [drawer, setDrawer] = useState(true);
  // const viewdatas = [
  //   {
  //     "ViewID": 1,
  //     "ViewName": "Returns View - Client Stmt"
  //   },{
  //     "ViewID": 2,
  //     "ViewName": "Returns View - Client Stmt (W/sub)"
  //   }
  // ];

  const [viewDatas, setViewDatas] = useState([]);
  const [Viewdata, setViewdata] = useState(null);
  const [settingsViewList, setSettingsViewList] = useState([]);
  const [settingsView, setSettingsView] = useState(null);
  const [settingsGroupingData, setSettingsGroupingData] = useState([]);
  const [settingsStatisticsData, setSettingsStatisticsData] = useState([]);
  const [settingsRepeatedAttributes, setSettingsRepeatedAttributes] = useState([]);
  const [isShared, setIsShared] = useState(false);
  const [isDateDesc, setIsDateDesc] = useState(false);
  const [availbleAttributes, setAvailableAttributes] = useState([]);
  const [selectedAvailableAttributes, setSelectedAvailableAttributes] = useState(null);
  const [availableStatistics, setAvailableStatistics] = useState([]);
  const [selectedAvailableStatistics, setSelectedAvailableStatistics] = useState(null);
  const [availableGrouping, setAvailableGrouping] = useState([]);
  const [selectedAvailableGrouping, setSelectedAvailableGrouping] = useState(null);
  const [availableDateOptions, setAvailableDateOptions] = useState([]);
  const [selectedAvailableDateOptions, setSelectedAvailableDateOptions] = useState(null);
  const [groupingGridAPI, setGroupingGridAPI] = useState(null);
  const [statisticsGridAPI, setStatisticsGridAPI] = useState(null);
  const [attributeGridAPI, setAttributeGridAPI] = useState(null);
  const [renameModalShow, setRenameModalShow] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [saveAsNameModal, setSaveAsNameModal] = useState(false);
  const [saveAsNameText, setSaveAsNameText] = useState("");
  const [renamedIsShared, setRenamedIsShared] = useState(false);
  const [renamedIsDateDesc, setRenamedIsDateDesc] = useState(false);
  const [renamedIsDefault, setRenamedIsDefault] = useState(false);


  const [saveAsIsShared, setSaveAsIsShared] = useState(false);
  const [saveAsIsDefault, setSaveAsIsDefault] = useState(false);


  const [valuationStatus,setValuationStatus]=useState([]);
  
  const [nYearsBack,setNYearsback]=useState(1);
  const [lastNYearsBack,setLastNYearsBack]=useState(1);
  const [CalendarYears,setCalendarYears]=useState(1);
  const [NPeriods,setNPeriods]=useState(null); 
  const showDateOptions=!(selectedAvailableStatistics?.EnumValue==1 || selectedAvailableStatistics?.EnumValue==2);

  const list_Grouping = settingsView?.AttrGroupingItem || [];
  const list_Statistics = settingsView?.AttrStatisticsItem?.filter((item) => item?.ListType === "S") || [];
  const list_Attributes = settingsView?.AttrStatisticsItem?.filter((item) => item?.ListType === "A") || [];
  const Level = [
    { BreadCrumb: "Portfolio >", Routes: `/${UrlPath.PortfolioList}` },
    {
      BreadCrumb: `Attribution`,
      Routes: `/${UrlPath.PortfolioAttribution}${portfolioId}`,
    },
  ];
  const groupString = Viewdata?.AttrGroupingItem?.length < 0 ? '' : '-' + Viewdata?.AttrGroupingItem?.map(item => item?.GroupId)?.join('-');

  const fetchViews = async (index) => {
    if(!index)
    index=0
    try {
      const list = await sbaAxios({
        url: getPortfolioAttributionViews
      });
      setViewDatas(list);
      setViewdata(list?.find((item) => item.IsDefault) || list[0]);
      setSettingsViewList(list);
      setSettingsView(list?.find((item) => item.IsDefault) || list[0]);
    }
    catch (e) {
      setViewDatas([]);
      setViewdata(null);
      setSettingsViewList([]);
      setSettingsView(null);
    }
  };

    const currentYear = new Date().getFullYear();
    const calendarYearsData = Array.from({ length: 20 }, (_, index) => ({
        EnumName: currentYear - index,
        EnumValue: index,
    }));
    
  const fetchAvailableAttributes = async () => {
    const list = await sbaAxios({
      url: getEnumerations + "Attribution_RepeatedAttributes"
    });
    setAvailableAttributes(list);
  };

    const fetchAvailableStatistics = async () => {
    const list = await sbaAxios({
      url: getEnumerations + "Attribution_AvailableStatistics"
    });
        setAvailableStatistics(list);
  };

  const fetchAvailableGrouping = async () => {
    const list = await sbaAxios({
      url: getEnumerations + "Attribution_Grouping"
    });
    setAvailableGrouping(list);
  };

    const fetchAvailableDateOptions = async () => {
    const list = await sbaAxios({
      url: getEnumerations + "Attribution_DateOptions"
    });
      setAvailableDateOptions(list);
  };


  useEffect(() => {
    fetchViews();
    fetchAvailableAttributes();
    fetchAvailableStatistics();
    fetchAvailableGrouping();
    GetReportClassificationsAPI();
    fetchAvailableDateOptions();
  }, []);

    useEffect(() => {
    if (settingsView !== null) {
      const list_Grouping = settingsView.AttrGroupingItem;
      const list_Statistics = settingsView.AttrStatisticsItem.filter((item) => item.ListType === "S");
      const list_Attributes = settingsView.AttrStatisticsItem.filter((item) => item.ListType === "A");
      setSettingsGroupingData(list_Grouping);
      setSettingsStatisticsData(list_Statistics);
      setSettingsRepeatedAttributes(list_Attributes);
      setIsShared(settingsView.IsShared);
      setIsDateDesc(settingsView.IsDateOrderDesc);
    }
  }, [settingsView]);

  const onGroupingGridReady = (params) => {
    setGroupingGridAPI(params.api);
  };
  const onStatisticsGridReady = (params) => {
    setStatisticsGridAPI(params.api);
  };
  const onAttributeGridReady = (params) => {
    setAttributeGridAPI(params.api);
  };

  useEffect(() => {
    document.title = "Portfolio Attribution";
    dispatch(getPortFolioListAction(null));
    dispatch(getPortFolioDiscretionaryStatusAction());
    dispatch(getPortFolioTaxStatusAction());
    dispatch(getPortFolioManagerAction());
    dispatch(getPortFolioCreditFacilityAction());
    dispatch(getPortFolioExpenseAction());
    dispatch(getPortFolioCashAction());
    dispatch(getPortFolioCurrencyAction());
    dispatch(getPortFolioTypeAction());
    dispatch(getTreeofFamilyCSAction(""));
    getFamilyData();
  }, []);

  useEffect(() => {
    dispatch(getPortFolioDetailAction(portfolioId));
  }, [portfolioId]);
  const getFamilyData = (searchText) => {
    const keyWord = searchText ? `/${searchText}` : ``
    sbaAxios({ url: `${getTreeofFamilyClientStatements}${keyWord}` }).then(res => {
      setFamilyList(res.map(family => ({ ...family, text: family.FamilyName, checked: false, type: 'family', expanded: false, items: family.ClientStatements.map(cs => ({ ...cs, text: cs.ClientStatementName, FamilyId: family.FamilyId, checked: false, type: 'clientStatement' })) })));
      setFamilyListBackUP(res.map(family => ({ ...family, text: family.FamilyName, checked: false, type: 'family', expanded: false, items: family.ClientStatements.map(cs => ({ ...cs, text: cs.ClientStatementName, FamilyId: family.FamilyId, checked: false, type: 'clientStatement' })) })));
    });
  };
  const handleDateChange = (e) => {
    if (e?.value) {
      const newStartDate = e.value.start !== null ? e.value.start : dateRange.start;
      const newEndDate = e.value.end !== null ? e.value.end : dateRange.end;
      setDateRange({ start: newStartDate, end: newEndDate });
    }
  };

  const legacyOutput = (data, genColumns,custDetails) => {
    try {

      let startDate=dateRange.start;
    startDate.setDate(1);
    const endData=dateRange.end;

      const attributesMonths = getMonthsBetweenDates(startDate, endData);
      let attributesWithoutGroups = []
      const monthlyAttributesColumn = attributesMonths.map((datuuu, Mindex) => (
        {
          headerName: datuuu,
          children: Viewdata.AttrStatisticsItem.filter(stats => stats.ListType == 'A').map(stats => {
            const newMonthlyAttribute = {
              headerName: `${datuuu.trim()}++${stats.KeyName}`,
              field: `${datuuu.trim()}++${stats.KeyName}`,
              useValueFormatterForExport: true,
              cellStyle: { textAlign: "right" },
              autoHeaderHeight: true,
              minWidth: 100,
              headerClass: stats.KeyName !== "InceptionDate" && 'right-aligned-header right-aligned-text',
              source: "Attribute",
              attributeIndex: stats.SortOrder,
              MonthIndex: Mindex,
              ...stats
            }
            attributesWithoutGroups.push(newMonthlyAttribute);
            return newMonthlyAttribute
          })
        }
      ));
      const formattedEntityLines = data.FundList.map((fund, index) => {
        let SecurityName = [fund.AssetName + "***" + fund.PortfolioShortName];
        if (data.StatsSubstrategyLevel.length > 0) {
          SecurityName.unshift(fund.SubStrategyName);
        }
        if (data.StatsStrategyLevel.length > 0) {
          SecurityName.unshift(fund.StrategyName);
        }
        if (data.StatsBillableLevel.length > 0) {
          SecurityName.unshift(fund.BillableName)
        }
        const fundStats = data.StatList[index];
        const OtherAttrList = data.OtherAttrList[index];
        const stats = {};
        genColumns.map((column, index) => {
          let name = column.KeyName;
          const StatsName = name;
          if (column.KeyName == "CompoundRORDaily") {
            if (column.Value) {
              name = name + column.Value;
            }
          }
          let value = fundStats[column.SortOrder]
          stats[name] = value;

        });
        attributesWithoutGroups.map(column => {
          const columnName = column.field;
          const statsName = column.KeyName;
          const attrributeValue = parseFloat(OtherAttrList?.[column.attributeIndex]?.[column.MonthIndex]) || 0;
          stats[columnName] = attrributeValue;
        });
        const custItems=custDetails?.find(citem=>fund.AssetId==citem.AssetID && fund.PortfolioId ==citem.PortfolioId) || {};
        return {
          ...fund,
          ...stats,
          ...custItems,
          exportTimeSeries: true,
          type: "security",
          SecurityName: SecurityName,
          showToolTip: true,
          selectedPortfolios: selectedPortfolio
        }
      }).sort((a, b) => {
        const nameA = a.AssetName.toLowerCase();
        const nameB = b.AssetName.toLowerCase();

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      })
      const billableLevels = {};
      const formattedBillableLines = data.StatsBillableLevel.map((item, index) => {
        if (item.LevelName == "Advised NonBillable")
          item.LevelName = "Advised Non-Billable"
        billableLevels[item.LevelIdentifier[0]] = item.LevelName;
        const SecurityName = [item.LevelName];
        const stats = {};
        const otherAttributes = data?.OtherBillableLevel?.[index]?.Levels || [];
        genColumns.map((column, index) => {
          let name = column.KeyName;
          const StatsName = name;
          if (column.KeyName == "CompoundRORDaily") {
            if (column.Value) {
              name = name + column.Value;
            }
          }
          let value = item.Levels[column.SortOrder];
          stats[name] = value;
        });
        attributesWithoutGroups.map(column => {
          const columnName = column.field;
          const statsName = column.KeyName;
          stats[columnName] = otherAttributes[column.MonthIndex]?.[column.attributeIndex];
        });
        return {
          ...item,
          ...stats,
          exportTimeSeries: true,
          type: "group",
          SecurityName: SecurityName,
          selectedPortfolios: selectedPortfolio
        }
      });
      const totalLines = data.TotalStatsPortfolioLevel.map((item, index) => {
        const SecurityName = ["Invested Capital Total"];
        const stats = {};
        const otherAttributes = data?.TotalOtherPortfolioLevel[0]?.Levels || [];
        genColumns.map((column, index) => {
          let name = column.KeyName;
          if (column.KeyName == "CompoundRORDaily") {
            if (column.Value) {
              name = name + column.Value;
            }
          }
          let value = item.Levels[column.SortOrder];
          stats[name] = value;
        });

        attributesWithoutGroups.map(column => {
          const columnName = column.field;
          const statsName = column.KeyName;
          stats[columnName] = otherAttributes[column.MonthIndex]?.[column.attributeIndex];
        });
        // const sortOrder=data.FundList.find(fund=>fund.StrategyId===item.FundId).StrategySortOrder; 
        return {
          ...stats,
          ...item,
          type: "total",
          SecurityName: SecurityName,
        }
      });
      const formattedStrategyLines = data.StatsStrategyLevel.map((item, index) => {
        const billableKey = item.LevelIdentifier[0];
        const billableName = billableLevels[billableKey];
        const SecurityName = billableName != undefined ? [billableName, item.LevelName] : [item.LevelName];
        const otherAttributes = data?.OtherStrategyLevel?.[index]?.Levels || [];
        const stats = {};

        genColumns.map((column, index) => {
          let name = column.KeyName;
          if (column.KeyName == "CompoundRORDaily") {
            if (column.Value) {
              name = name + column.Value;
            }
          }
          let value = item.Levels[column.SortOrder];
          stats[name] = value;
        });
        attributesWithoutGroups.map(column => {
          const columnName = column.field;
          const statsName = column.KeyName;
          stats[columnName] = otherAttributes[column.MonthIndex]?.[column.attributeIndex];
        });
        const sortOrder = data?.FundList?.find(fund => fund.StrategyId === item.FundId)?.StrategySortOrder || 0;
        return {
          ...stats,
          ...item,
          SortOrder: sortOrder,
          exportTimeSeries: true,
          type: "group",
          SecurityName: SecurityName,
          selectedPortfolios: selectedPortfolio
        }
      }).sort((a, b) => a - b);
      const formattedSSubStrategyLines = data.StatsSubstrategyLevel.map((item, index) => {
        const billableKey = item.LevelIdentifier[0];
        const strategykey = item.LevelIdentifier[1];
        const strategyName = formattedStrategyLines.find(item => item.FundId == strategykey)?.LevelName || "";
        const billableName = billableLevels[billableKey];
        const otherAttributes = data?.OtherBillableLevel?.[index]?.Levels || [];

        let SecurityName = [item.LevelName];

        if (strategyName != undefined) {
          SecurityName.unshift(strategyName);
        }
        if (billableName != undefined) {
          SecurityName.unshift(billableName);
        }


        // let SecurityName=[billableName,strategyName,item.LevelName];

        const stats = {};
        genColumns.map((column, index) => {
          let name = column.KeyName;
          if (column.KeyName == "CompoundRORDaily") {
            if (column.Value) {
              name = name + column.Value;
            }
          }
          let value = item?.Levels[column?.SortOrder];
          stats[name] = value;
        });

        attributesWithoutGroups.map(column => {
          const columnName = column.field;
          const statsName = column.KeyName;
          stats[columnName] = otherAttributes[column.MonthIndex]?.[column.attributeIndex];
        });
        //const sortOrder=data.FundList.find(fund=>fund.StrategyId===item.FundId).StrategySortOrder; 
        return {
          ...stats,
          ...item,
          //SortOrder:sortOrder,
          exportTimeSeries: true,
          type: "group",
          SecurityName: SecurityName,
          selectedPortfolios: selectedPortfolio
        }
      });
      console.log(formattedEntityLines,'formattedEntityLines')
      setGridData(value => [...formattedBillableLines, ...formattedStrategyLines, ...formattedSSubStrategyLines, ...formattedEntityLines, ...totalLines]);
      setIsDataLoading(false);
    } catch (error) {
      console.log(error, 'error formating grid data');
    }
  };
  const getAttributionData = async (dateRange, portfolios ,valuationStatus,CustodianDetails) => {
    const endDate = dateRange.end.toISOString().slice(0, 10) + "T00:00:00";
    const startDate = dateRange.start.toISOString().slice(0, 10) + "T00:00:00";
    try {
      const selectedStatsList = Viewdata.AttrStatisticsItem.filter(stats => stats.ListType == 'S').map(stat => ({
        "FriendlyName": stat.FriendlyName,
        "KeyName": stat.KeyName,
        "DateType": 0,
        "EnhancedType": stat.EnhancedType,
        "Years": 0,
        "Periods": 0,
        "CumulativePeriods": true,
        "CalendarYearDate": null,
        "StatStartDate": null,
        "StatEndDate": null,
        "Annualized": false,
        "StatToRun": null,
        "Category": null,
        "IsAltBMSet": false,
        "AltBM": null,
        "ReturnsLimit": 0,
        "RollingWindowType": 0,
        "IsCompleted": false,
        "UseEstEndDate": false,
        "IRRBasket": 0,
        "IRRFund": 0,
        "GroupKey": 0,
        "GroupName": null,
        "WidgetKey": 0,
        "WidgetName": null

      }));
      const postData = portfolios?.map(item => (
        {
          "PortfolioId": item.PortfolioId,
          "PortfolioName": "",
          "ShortName": null,
          "Description": null,
          "StartDate": startDate,
          "EndDate": endDate,
          "EntityList": null,
          "PortfolioLevel": null,
          "StatsList": selectedStatsList,
          "StartDateType": 0,
          "EndDateType": 1,
          "IsStoreData": false,
          "LevelCombo": 7,
          "MasterLevel": null,
          "PortfolioTypeId": 0,
          "UseHistory": false,
          "CalculateNonPerf": false,
          "IsConsolidated": false,
          "WriteReturns": false,
          "HoldbackList": null,
          "FITList": null,
          "CEList": null,
          "CashOnly": null,
          "PortfolioIds": null,
          "PartnershipId": 0,
          "IsPartnership": item?.IsPartnership || false,
          "BackingPortfolioId": 0,
          "IsFlashSummary": false,
          "FLEntities": [],
          "IsCoverAggregatedPartner": false,
          "CPEntities": [],
          "PartnerAggregateLevel": null,
          "PartnershipPortfolioId": 0,
          "UseInvClassification": false,
          "PartnerCalculate": false,
          "RunWeights": true,
          "SupressLog": false,
          "DoLookThrough": false,
          "IsPPLI": false,
          "PPLICombine": false,
          "ClientStatementId": 0
        }));
      setIsDataLoading(true);
        const Attribution = await sbaAxios({
            url: addQueryString(getPortfolioAttributionUIData + `?hideZero=${false}&viewId=${Viewdata.ViewID}&grouping=${groupString}`,"ReportClassificationId",selectedReportClassification.ReportClassificationId), data: postData, method: 'post'
        });
        const generatedColumn = getColumnData(Attribution,valuationStatus);
        legacyOutput(Attribution, generatedColumn,CustodianDetails);
    } catch (error) {
      setIsDataLoading(false);
      SBNotify({ Msg: "Some Exception Occurred Please Contact Admin", type: 'error' });
      setGridData([]);
      setColDef([]);
    }
  };
  const getRowData = async (Attribution, dateRange) => {
    const feeLine = Attribution.EntityList.find(item => item.IsFeesLine);
    const FeeLineStatResults = {};
    feeLine.StatsList.forEach(item => {
      if (item.Stat.KeyName === 'LastNYears')
        FeeLineStatResults[item.Stat.KeyName + item.Stat.Years] = percentageValueFormatter(item.Results * -1);
      else
        FeeLineStatResults[item.Stat.KeyName] = percentageValueFormatter(item.Results * -1);
    });

    const advisedTotal = {};
    const nonAdvisedTotal = {};
    const otherPerf = {};


    const allData = Attribution.EntityList.map(item => {
      const statResults = {};
      item.StatsList.forEach(item => {
        if (item.Stat.KeyName === 'LastNYears')
          statResults[item.Stat.KeyName + item.Stat.Years] = percentageValueFormatter(item.Results);
        else
          statResults[item.Stat.KeyName] = percentageValueFormatter(item.Results);
      });
      const formattedDate = dateRange.end.toISOString().slice(0, 10) + "T00:00:00";
      const attribute = item.MonthlyAttributes.find(item => item.RptDate === formattedDate);
      return {
        ...statResults, ...item,
        EMV: formatCurrencyValue(attribute?.EMV),
        BMV: formatCurrencyValue(attribute?.BMV),
        PortfolioId: item.PortfolioId,
        EndPercentage: percentageValueFormatter(attribute?.EndPercentage),
        StrategyId: item.StrategyId,
        StrategyName: item.StrategyName,
        AssetId: item.AssetId,
        AssetName: item.AssetName,
        InceptionDate: item.InceptionDate ? moment(item.InceptionDate).format('MM-DD-YYYY') : "",
        ShortName: item.ShortName,
        IsAdvised: item.IsAdvised,
        IsAdvisedLine: item.IsAdvisedLine,
        IsBillable: item.IsBillable,
        IsMarketable: item.IsMarketable,
        IsPerforming: item.IsPerforming,
        IsShareBased: item.IsShareBased,
        IsStrategyLine: item.IsStrategyLine,
        IsTotalLine: item.IsTotalLine,
        IsIndexLine: item.IsIndexLine,
        IsFeesLine: item.IsFeesLine,
        SortOrder: item.SortOrder
      }
    })
    const onlyEntitiesLine = allData.filter(item => item.IsEntity || item.IsIndexLine || item.IsFeesLine);
    const withoutIndexdata = allData.filter(item => !item.IsIndexLine && !item.IsIndexLine);
    const inedxLines = allData.filter(item => item.IsIndexLine);
    const formattedData = allData.map((item, index) => {
      if (item.AssetName === "Invested Performing Total") {
        return { SecurityName: ["Other-Perfroming", item?.AssetName], ...item };
      }
      else if (item.AssetName === "Total Assets Excluded from Performance") {
        return { SecurityName: ["Non-Advised", item?.AssetName], ...item };

      }
      else if (item.AssetName === "Total Portfolio") {
        return { SecurityName: ["Total Portfolio"], ...item };

      }
      // Advised Section
      if (item.IsAdvised) {
        if (item.AssetId == 9999) {
          return { SecurityName: ["Advised"], ...item };
        }
        else if (item.IsStrategyLine) {
          return { SecurityName: ["Advised", item?.AssetName], ...item };
        }
        else if (item.IsIndexLine) {
          return { SecurityName: ["Advised", item.StrategyName, item?.AssetName], ...item };
        }
        else if (item.IsFeesLine) {
          return { SecurityName: ["Advised", item?.AssetName], ...item };

        }
        else {
          return { SecurityName: ["Advised", item.StrategyName, item?.AssetName], ...item };
        }
      }
      else if (!item.IsAdvised) {
        // other perfroming  and         
        if (item.IsPerforming) {
          if (item.IsStrategyLine) {
            return { SecurityName: ["Other-Perfroming", item?.AssetName], ...item };
          }
          else if (item.IsIndexLine) {
            return { SecurityName: ["Other-Perfroming", item.StrategyName, item?.AssetName], ...item, SortOrder: 9999 };
          }
          else if (item.IsFeesLine) {
            return { SecurityName: ["Other-Perfroming", item?.AssetName], ...item };
          }
          else {
            return { SecurityName: ["Other-Perfroming", item.StrategyName, item?.AssetName], ...item };
          }
        }
        // non-advised section
        else {
          if (item.AssetId == 9999) {
            return { SecurityName: ["Non-Advised"], ...item };
          }
          else if (!item.IsPerforming) {
            if (item.IsStrategyLine) {
              if (item.AssetName = 'Cash and Equivalents')
                return { SecurityName: ["Non-Advised", item?.AssetName], ...item };
              else
                return { SecurityName: ["Other-Perfroming", item?.AssetName], ...item };
            }
            else if (item.IsIndexLine) {
              return { SecurityName: ["Other-Perfroming", item.StrategyName, item?.AssetName], ...item };
            }
            else if (item.IsFeesLine) {
              return { SecurityName: ["Non-Advised", item?.AssetName], ...item };
            }
            else {
              return { SecurityName: ["Non-Advised", item.StrategyName, item?.AssetName], ...item };
            }
          }
        }
      }
      else {
        return { SecurityName: [item?.AssetName], ...item };
      }
    }).sort((a, b) => {
      if (a.AssetName === "Total Assets Excluded from Performance" || a.AssetName === "Invested Performing Total")
        return 1
      else if (a.AssetName === "Total Assets Excluded from Performance" || a.AssetName === "Invested Performing Total")
        return -1
      return 0
    });
    setGridData(val => [...formattedData].sort((a, b) => a.SortOrder - b.SortOrder));
    setIsDataLoading(false);
  };
  const getColumnData = (Attribution,valuationStatus) => {

    const EMVDate = moment(dateRange.end).format('MM/DD');
    const BMVDate = moment(dateRange.end).format('MM') + '/01';
    let startDate=dateRange.start;
    startDate.setDate(1);
    const endData=dateRange.end;
    const attributesMonths = getMonthsBetweenDates(startDate, endData);
    const returnFields = [{
      headerName: `BMV (${BMVDate})`,
      field: `BMV`,
      useValueFormatterForExport: true,
      cellStyle: { textAlign: "right" },
      minWidth: 200,
      headerClass: 'right-aligned-header right-aligned-text'
    },
    {
      headerName: `EMV (${EMVDate})`,
      field: `EMV`,
      useValueFormatterForExport: true,
      cellStyle: { textAlign: "right" },
      minWidth: 200,
      headerClass: 'right-aligned-header right-aligned-text'
    },
    {
      headerName: 'End %',
      field: `EndPercentage`,
      useValueFormatterForExport: true,
      cellStyle: { textAlign: "right" },
      minWidth: 200,
      headerClass: 'right-aligned-header right-aligned-text'
    }];
    const formattedData = Attribution?.StatsList?.map(item => {
      let headerName = ''
      if (item.KeyName === 'MTD' || item.KeyName === 'QTD' || item.KeyName === 'YTD')
        headerName = `${item.KeyName} TWR`
      else if (item.Years === 3) {
        headerName = `TWR (Last 3 Year)`
        return {
          headerName: headerName,
          field: item.KeyName + 3,
          useValueFormatterForExport: true,
          cellStyle: { textAlign: "right" },
          autoHeaderHeight: true,
          minWidth: 100,
          headerClass: 'right-aligned-header right-aligned-text'
        }
      }
      else if (item.Years === 5) {
        headerName = `TWR (Last 5 Year)`
        return {
          headerName: headerName,
          field: item.KeyName + 5,
          useValueFormatterForExport: true,
          cellStyle: { textAlign: "right" },
          autoHeaderHeight: true,
          minWidth: 100,
          headerClass: 'right-aligned-header right-aligned-text'
        }
      }
      else if (item.KeyName === 'ITD') { headerName = `ITD TWR (A)` }
      else { headerName = item.FriendlyName; }
      return {
        headerName: headerName,
        field: item.KeyName,
        useValueFormatterForExport: true,
        cellStyle: { textAlign: "right" },
        autoHeaderHeight: true,
        minWidth: 100,
        headerClass: 'right-aligned-header right-aligned-text',
      }
    });
    const ShortName = {
      headerName: 'Short Name',
      field: `PortfolioShortName`,
      useValueFormatterForExport: true,
      cellStyle: { textAlign: "right" },
      autoHeaderHeight: true,
      pinned: "left",
      maxWidth: 100,
      headerClass: 'right-aligned-header right-aligned-text'
    };
    const inceptionDate = {
      headerName: 'Inception Date',
      field: `InceptionDate`,
      valueFormatter: dateFormatter,
      useValueFormatterForExport: true,
      cellStyle: { textAlign: "right" },
      autoHeaderHeight: true,
      minWidth: 125,
      headerClass: 'right-aligned-header right-aligned-text'
    };
    const sortOrder = {
      field: 'SortOrder',
      headerName: 'sort',
    };
    const legacyColumn = attributionColumns.map(item => {
      let name = item.KeyName;
      if (item.KeyName == "CompoundRORDaily") {
        if (item.Value) {
          name = name + item.Value;
        }
      }
      return {
        headerName: item.FriendlyName,
        field: name,
        useValueFormatterForExport: true,
        cellStyle: { textAlign: "right" },
        autoHeaderHeight: true,
        minWidth: 100,
        headerClass: item.KeyName !== "InceptionDate" && 'right-aligned-header right-aligned-text',
      }
    });

    const statsColumns = Viewdata.AttrStatisticsItem.filter(stats => stats.ListType == 'S').map(stats => {
      const className = GetExcelFormat(stats.KeyName);
      if(stats.KeyName === "EMV")
      {
        return {
          headerName: stats.FriendlyName,
          field: stats.KeyName,
          useValueFormatterForExport: true,
          cellStyle: { textAlign:stats.KeyName !== "InceptionDate" ? "right" : "unset" },
          autoHeaderHeight: true,
          minWidth: 150,
          cellRenderer:(params) => {
            const val = valuationStatus.find(item => item.AssetId == params.data.AssetId && item.PortfolioId == params.data.PortfolioId) || {};
            console.log('valuation status: ', val.ValuationStatus);

            // Define border color classes based on ValuationStatus
            const borderClass = val.ValuationStatus === 'A' ? 'border-success' : 
                                val.ValuationStatus === 'E' ? 'border-primary' : 
                                val.ValuationStatus === 'S' ? 'border-danger' : '';

            return (
                <>
                    {formatStats(params.value, stats.KeyName)}
                    {val.ValuationStatus !== 'U' && val.ValuationStatus && (
                        <sup className={`text-bold fw-bold mx-1 rounded border px-1 SBA_hand ${borderClass}`}>
                            {val.ValuationStatus}
                        </sup>
                    )}
                </>
            );
          },
          headerClass: stats.KeyName !== "InceptionDate" && 'right-aligned-header right-aligned-text',
          source: "Stats",
          cellClass: (params) => { if (parseFloat(params.value) != 0) { return className; } else return "noneFormat" },
          // valueFormatter: ,
          ...stats
        }
      }
      else 
      return {
        headerName: stats.FriendlyName,
        field: stats.KeyName,
        useValueFormatterForExport: true,
        cellStyle: { textAlign:stats.KeyName !== "InceptionDate" ? "right" : "unset" },
        autoHeaderHeight: true,
        minWidth: 150,
        // cellRenderer:(props)=>{
        //   if(stats.KeyName=="BMV" || stats.KeyName=="EMV"  )
        //   {
        //     return <>{formatCurrencyValue(props.value)}</>
        //   }
        //   else if(stats.KeyName=="InceptionDate"){
        //     return <>{dateFormatter(props.value)}</>
        //   }
        //   else 
        //   return <>{percentageValueFormatter(props.value)}</>
        // },
        headerClass: stats.KeyName !== "InceptionDate" && 'right-aligned-header right-aligned-text',
        source: "Stats",
        cellClass: (params) => { if (parseFloat(params.value) != 0) { return className; } else return "noneFormat" },
        valueFormatter: (params) => {
          if(stats.KeyName=="InceptionDate")
          {
            return params.value
          }
           return formatStats(params.value, stats.KeyName)},
        ...stats
      }
    });
    let attributesWithoutGroups = []
    const monthlyAttributesColumn = attributesMonths.map(datuuu => (
      {
        headerName: datuuu,
        children: Viewdata.AttrStatisticsItem.filter(stats => stats.ListType == 'A').map(stats => {
          const className = GetExcelFormat(stats.KeyName);
          const newMonthlyAttribute = {
            headerName: stats.FriendlyName,
            field: `${datuuu.trim()}++${stats.KeyName}`,
            useValueFormatterForExport: true,
            cellStyle: { textAlign:stats.KeyName !== "InceptionDate" ? "right" : "unset" },
            autoHeaderHeight: true,
            minWidth: 150,
            headerClass: stats.KeyName !== "InceptionDate" && 'right-aligned-header right-aligned-text',
            source: "Attribute",
            cellClass: (params) => { if (parseFloat(params.value) != 0) { return className; } else return "noneFormat" },
            valueFormatter: (params) => {
              if(stats.KeyName=="InceptionDate")
              {
                return params.value
              }
              return formatStats(params.value, stats.KeyName)},
            ...stats
          }
          attributesWithoutGroups.push(newMonthlyAttribute);
          return newMonthlyAttribute
        })
      }
    ));
    if (Viewdata.AttrStatisticsItem.filter(stats => stats.ListType == 'A').length > 0) {
      setColDef(val => [ShortName, ...statsColumns, ...monthlyAttributesColumn]);
    }
    else {
      setColDef(val => [ShortName, ...statsColumns]);

    }
    return [...statsColumns];
  };
  const dateFormatter = (params) => {
    const value = params?.data?.InceptionDate;
    if (value)
      return moment(value).format('MM/DD/YYYY');
    else
      return '';
  };
  const getGridData =async () => {
    if (portfolio.length === 0) {
      SBNotify({ Msg: "Please Select Any Portfolio", type: "error" });
      return;
    }
    if (dateRange?.start && dateRange?.end) {
     
      const portfolioIDs = portfolio?.map(item => item.PortfolioId).join(',');
      const CustodianDetails=await getCustodianDetails(moment(dateRange?.end).format("MM/DD/yyyy"),portfolioIDs);
      if (Viewdata.ShowValuation) {
        sbaAxios({
            url: `${getValuationStatus}ReportDate=${moment(dateRange?.end).format("MM/DD/yyyy")}&PortfolioIDs=${portfolioIDs}`
        }).then((res) => {
            getAttributionData(dateRange, portfolio, res,CustodianDetails);
        }).catch((error) => {
            console.error("Error fetching valuation data:", error);
        });
    } else {
        getAttributionData(dateRange, portfolio, [],CustodianDetails);
    }
    
    }

  };
  const getValuationStatusData=(endDate,portfolios)=>{
    try {
    } catch (error) {
      
    }
  }
  const OpenDocumentsDrawer = async () => {
    const date = new Date();
    const reportData = new Date(date.getFullYear(), date.getMonth(), 0);
    const documentList = [];
  
    for (const obj of clientStatements) {
      try {
        const response = await sbaAxios({
          url: `${getCSAccordion}?clientStatementId=${obj.csID}&documentDate=${reportData.toISOString()}&@NrOfDocsPerCategory=30`,
        });
  
        // Make sure the response is valid
        if (Array.isArray(response) && response.length > 0) {
          // Filter Manager Statement documents
          const managerStatements = response.filter(
            doc => doc.DocumentCategoryName === "Manager Statement"
          );
  
          // Sort by DocumentDate (most recent first) and take top 3
          const recent3 = managerStatements
            .sort((a, b) => new Date(b.DocumentDate) - new Date(a.DocumentDate))
            .slice(0, 3);
  
          documentList.push({"ClientStatementName":obj.csName,"docs":[...recent3]});
        }
      } catch (error) {
        console.error(`Error fetching documents for csID ${obj.csID}:`, error);
      }
    }
  
    // Update state
    setShowDocumentDrawer(true);
    // Assuming you want to store these somewhere, for example:
    // setFilteredDocuments(documentList);
    setManagerStatementDocumentList(documentList);
  };
  
  // custom view
  const OpenCustomWindow = () => {

    if (portfolio.length === 0) {

      SBNotify({ Msg: "Please select Portfolio", type: "error" });
    }
    else {
      setshowView(true);

    }
  };
  var statisticsColumnDefs = [
    {
      field: "FriendlyName",
      headerName: "Statistics Name",
    },
  ];
  var groupingColumnDefs = [
    {
      field: "GroupItemName",
      headerName: "Grouping Name"
    },
  ];
  var attributeColumnDefs = [
    {
      field: "FriendlyName",
      headerName: "Attribute Name"
    },
  ];
  const defaultColDef = {
    sortable: true,
    filter: true,
    floatingFilter: true,
    flex: 1,
    filter: "agTextColumnFilter",
    resizable:true
  };
  const addGrouping = () => {
    if (selectedAvailableGrouping) {
      const rowData = [];
      groupingGridAPI.forEachNode((node) => rowData.push(node.data));
      if (rowData.some((item) => item.GroupItemName === selectedAvailableGrouping.EnumName)) {
        toast.error('Grouping already exists.');
      }
      else {
        const newGrouping = {
          GroupId: selectedAvailableGrouping.EnumValue,
          GroupItemName: selectedAvailableGrouping.EnumName,
          SortOrder: list_Grouping?.length + 1,
          Value: selectedAvailableGrouping.EnumValue
        };
        groupingGridAPI.applyTransaction({ add: [newGrouping] });
        setSettingsView(val => ({ ...val, AttrGroupingItem: [newGrouping, ...val.AttrGroupingItem] }));
      }
    }
    else {
      toast.error('Please select a Grouping');
    }
  };
  const addStatistics = () => {
    const newStatistics = [];
    if (selectedAvailableStatistics) {
      const rowData = [];
      statisticsGridAPI.forEachNode((node) => rowData.push(node.data));
        const sortOrder = (rowData?.length || 0) > 0 ? rowData.length + 1 : 1;
        if(selectedAvailableStatistics.EnumValue==1)
        {
          if (selectedAvailableDateOptions?.EnumValue == 1) {
            newStatistics.push({
              EnhancedType: 0,
              FriendlyName: "YTD TWR",
              KeyName: "CompoundRORDaily",
              CoreValue: null,
              Value: null,
              Annualized: false,
              SortOrder: sortOrder,
              ListType: "S"
            });
          }
          else if (selectedAvailableDateOptions?.EnumValue == 2) {
            newStatistics.push({
              EnhancedType: 6,
              FriendlyName: "MTD TWR",
              KeyName: "MTD",
              CoreValue: null,
              Value: null,
              Annualized: false,
              SortOrder: sortOrder,
              ListType: "S"
            });
          }
          else if (selectedAvailableDateOptions?.EnumValue == 3) {
            newStatistics.push({
              EnhancedType: 7,
              FriendlyName: "QTD TWR",
              KeyName: "QTD",
              CoreValue: null,
              Value: null,
              Annualized: false,
              SortOrder: sortOrder,
              ListType: "S"
            });
          }
          else if (selectedAvailableDateOptions?.EnumValue == 4) {
            newStatistics.push({
              EnhancedType: 8,
              FriendlyName: "ITD TWR",
              KeyName: "ITD",
              CoreValue: null,
              Value: null,
              Annualized: true,
              SortOrder: sortOrder,
              ListType: "S"
            });
          }
          else if (selectedAvailableDateOptions?.EnumValue == 5) {
            if(nYearsBack>0)
            {
            const currentYear = new Date().getFullYear();
            const yearDifference = currentYear - nYearsBack;
            const value = `TWR (${yearDifference})`;
            newStatistics.push({
              EnhancedType: 1,
              FriendlyName: value,
              KeyName: "CompoundRORDaily",
              CoreValue: nYearsBack,
              Value: nYearsBack,
              Annualized: false,
              SortOrder: sortOrder,
              ListType: "S"
            });
           }
           else 
           {
            toast.error('Please Enter the Years');
           }

          }
          else if (selectedAvailableDateOptions?.EnumValue == 6) {
            if(lastNYearsBack>0)
            {
            newStatistics.push({
              EnhancedType: 2,
              FriendlyName: `TWR (Last ${lastNYearsBack} Years)`,
              KeyName: `CompoundRORDaily`,
              CoreValue: lastNYearsBack,
              Value: lastNYearsBack,
              Annualized: false,
              SortOrder: sortOrder,
              ListType: "S"
            });
            }
            else {
              toast.error('Please Enter the Years');
            }
          }
          else if (selectedAvailableDateOptions?.EnumValue == 7) {
            if(CalendarYears?.EnumName)
            {
            const currentYear = new Date().getFullYear();
            const selectedyear = parseInt(CalendarYears.EnumName);
            const YearDifference = currentYear - selectedyear;
            newStatistics.push({
              EnhancedType: 3,
              FriendlyName: `TWR ${CalendarYears.EnumName}`,
              KeyName: `CompoundROR`,
              CoreValue: CalendarYears.EnumName,
              Value: YearDifference,
              Annualized: false,
              SortOrder: sortOrder,
              ListType: "S"
            });
           }
           else
           {
             toast.error('Please Select the Year');
           }

            // statisticsGridAPI.applyTransaction({ add: newStatistics });
            // setSettingsView(val => ({ ...val, AttrStatisticsItem: [...newStatistics, ...val.AttrStatisticsItem] }));
          }
          else if (selectedAvailableDateOptions?.EnumValue == 8) {
            if(NPeriods?.EnumValue)
            {
            const  monthYear=moment(calSubtractMonths(NPeriods.EnumValue)).format('MMMM-YYYY');
            newStatistics.push({
              EnhancedType: 4,
              FriendlyName: `TWR `+monthYear,
              KeyName: "CompoundROR",
              CoreValue: null,
              Value: NPeriods.EnnumValue,
              Annualized: false,
              SortOrder: sortOrder,
              ListType: "S"
            });
            }
            else
            {
              toast.error('Please Select the Value');
            }
          }
          else if (selectedAvailableDateOptions?.EnumValue == 9) {
            newStatistics.push({
              EnhancedType: 5,
              FriendlyName: `TWR`,
              KeyName: `CompoundROR`,
              CoreValue: null,
              Value: null,
              Annualized: false,
              SortOrder: sortOrder,
              ListType: "S"
            });
          }
          else {
            // newStatistics.push({
            //   EnhancedType: 0,
            //   FriendlyName: selectedAvailableStatistics.EnumName,
            //   KeyName: selectedAvailableStatistics.EnumName.trim(),
            //   CoreValue: null,
            //   Value: null,
            //   Annualized: false,
            //   SortOrder: sortOrder,
            //   ListType: "S"
            // })
          }
        }
        else if (selectedAvailableStatistics.EnumValue == 2) {
          if (selectedAvailableDateOptions?.EnumValue == 1) {
            newStatistics.push({
              EnhancedType: 0,
              FriendlyName: "Cumulative ROR YTD",
              KeyName: "CumulativeROR",
              CoreValue: null,
              Value: null,
              Annualized: false,
              SortOrder: sortOrder,
              ListType: "S"
            });
          }
          else if (selectedAvailableDateOptions?.EnumValue == 2) {
            newStatistics.push({
              EnhancedType: 6,
              FriendlyName: "Cumulative ROR MTD",
              KeyName: "MTD",
              CoreValue: null,
              Value: null,
              Annualized: false,
              SortOrder: sortOrder,
              ListType: "S"
            });
          }
          else if (selectedAvailableDateOptions?.EnumValue == 3) {
            newStatistics.push({
              EnhancedType: 7,
              FriendlyName: "Cumulative ROR Qtd",
              KeyName: "QTD",
              CoreValue: 2,
              Value: null,
              Annualized: false,
              SortOrder: sortOrder,
              ListType: "S"
            });
          }
          else if (selectedAvailableDateOptions?.EnumValue == 4) {
            newStatistics.push({
              EnhancedType: 8,
              FriendlyName: "Cumulative ROR ITD (A)",
              KeyName: "ITD",
              CoreValue: null,
              Value: null,
              Annualized: true,
              SortOrder: sortOrder,
              ListType: "S"
            });
          }
          else if (selectedAvailableDateOptions?.EnumValue == 5) {
            if(nYearsBack>0)
            {
              const currentYear = new Date().getFullYear();
              const yearDifference = currentYear - nYearsBack;
              const value = `Cumulative ROR (${yearDifference})`;
              newStatistics.push({
                EnhancedType: 1,
                FriendlyName: value,
                KeyName: "CumulativeROR",
                CoreValue: nYearsBack,
                Value: nYearsBack,
                Annualized: false,
                SortOrder: sortOrder,
                ListType: "S"
              });
            }
            else {
              toast.error('Please Enter the Years');
            }
            
          }
          else if (selectedAvailableDateOptions?.EnumValue == 6) {
            if(lastNYearsBack>0)
            {
            newStatistics.push({
              EnhancedType: 2,
              FriendlyName: `Cumulative ROR (Last ${lastNYearsBack} Years)`,
              KeyName: `CumulativeROR`,
              CoreValue: lastNYearsBack,
              Value: lastNYearsBack,
              Annualized: false,
              SortOrder: sortOrder,
              ListType: "S"
            });
            }
            else 
            {
              toast.error('Please Enter the Years');

            }
          }
          else if (selectedAvailableDateOptions?.EnumValue == 7) {
            if(CalendarYears?.EnumName)
            {
            const currentYear = new Date().getFullYear();
            const selectedyear = parseInt(CalendarYears.EnumName);
            const YearDifference = currentYear - selectedyear;
            newStatistics.push({
              EnhancedType: 3,
              FriendlyName: `TWR ${CalendarYears.EnumName}`,
              KeyName: `CompoundROR`,
              CoreValue: CalendarYears.EnumName,
              Value: YearDifference,
              Annualized: false,
              SortOrder: sortOrder,
              ListType: "S"
            });
            }
            else
            {
              toast.error('Please Select the Year');
            }

            // statisticsGridAPI.applyTransaction({ add: newStatistics });
            // setSettingsView(val => ({ ...val, AttrStatisticsItem: [...newStatistics, ...val.AttrStatisticsItem] }));
          }
          else if (selectedAvailableDateOptions?.EnumValue == 8) {
            if(NPeriods?.EnumValue)
            {
            const  monthYear=moment(calSubtractMonths(NPeriods.EnumValue)).format('MMMM-YYYY');
          
            newStatistics.push({
              EnhancedType: 4,
              FriendlyName: "Cumulative ROR "+ monthYear,
              KeyName: "CumulativeROR",
              CoreValue: null,
              Value: NPeriods.EnnumValue,
              Annualized: false,
              SortOrder: sortOrder,
              ListType: "S"
            });
            }
            else
            {
              toast.error('Please Select the Value');
            }
          }
          else if (selectedAvailableDateOptions?.EnumValue == 9) {
            newStatistics.push({
              EnhancedType: 5,
              FriendlyName: `CumulativeROR`,
              KeyName: `CompoundROR`,
              CoreValue: null,
              Value: null,
              Annualized: false,
              SortOrder: sortOrder,
              ListType: "S"
            });
          }
          else {
            // newStatistics.push({
            //   EnhancedType: 0,
            //   FriendlyName: selectedAvailableStatistics.EnumName,
            //   KeyName: selectedAvailableStatistics.EnumName.trim(),
            //   CoreValue: null,
            //   Value: null,
            //   Annualized: false,
            //   SortOrder: sortOrder,
            //   ListType: "S"
            // })
          }
        }
        else {
          newStatistics.push({
            EnhancedType: -1,
            FriendlyName: selectedAvailableStatistics.EnumName,
            KeyName: selectedAvailableStatistics.EnumDescription,
            CoreValue: null,
            Value: null,
            Annualized: false,
            SortOrder: sortOrder,
            ListType: "S"
          })
        }
        if(newStatistics.length==1)
        {
          const ItemToAdded=newStatistics[0];
          const attributionView=settingsView?.AttrStatisticsItem?.filter(item=>item.ListType=="S")?.find(item=>(item.FriendlyName==ItemToAdded.FriendlyName));
          if(!attributionView)
          setSettingsView(val => ({ ...val, AttrStatisticsItem: [...val.AttrStatisticsItem,...newStatistics] }));
          else {
            toast.error('Selected Stats Already Exist');
          }
        }
    
    } else {
      toast.error('Please select a Statistics');
    }
  };
  const addAttribute = () => {
    if (selectedAvailableAttributes) {
      const rowData = [];
      attributeGridAPI.forEachNode((node) => rowData.push(node.data));
      const sortOrder = (rowData?.length || 0) > 0 ? rowData.length + 1 : 1;
      
      if (rowData.some((item) => item.FriendlyName === selectedAvailableAttributes.EnumName)) {
        toast.error('Attribute already exists.');
      }
      else {
        const newAttribute = {
          EnhancedType: 0,
          FriendlyName: selectedAvailableAttributes.EnumName,
          KeyName: selectedAvailableAttributes.Description,
          CoreValue: null,
          Value: null,
          Annualized: false,
          SortOrder: sortOrder,
          ListType: "A"
        };
        setSettingsView(val => ({ ...val, AttrStatisticsItem: [ ...val.AttrStatisticsItem,...[newAttribute]] }));
      }
    }
    else {
      toast.error('Please select an Attribute');
    }
  };
  const nNumbersdata = Array.from({ length: 240 }, (_, index) => ({
    EnumName: index + 1,
    EnumValue: index + 1,
  }));
  const saveSelectedView = () => {
    const data = {...settingsView}
    if(list_Attributes.length>0)
    {
      data.ShowValuation=false
    }
    // data.ShowValuation= data list_Attributes.length>0 ? false :true ;
    sbaAxios({ url: UpdateAttributionCustomViewsAPI, method: "post", data: data }).then((res) => {
      toast.success('View Updated Succesfully');
      fetchViews();
    });
  };
  const createNewView=()=>{
    const index=settingsViewList.length;
    if(saveAsNameText.trim().length>0)
    {
      const data ={ ...settingsView,ViewName:saveAsNameText,IsDefault:saveAsIsDefault,IsShared:saveAsIsShared};
      sbaAxios({ url: insertNewAttrAPI, method: "post", data: data }).then((res) => {
        toast.success('View Added Succesfully');
        fetchViews(index);
        setSaveAsNameText("");
        setSaveAsNameModal(false);
      });
    }
   
  };
  const handleViewDelete = async() => {
      try{
        await sbaAxios({
          url:deleteView,
          params:{
            ViewId:settingsView.ViewID
          },
          method:'post'
        });
        toast.success('View deleted successfully');
      }
      catch(e){
        toast.error('unable to delete view.')
      }
      finally{
        fetchViews();
        setDeleteModalShow(false);
      }
  };
  const handleRenameView = async() => {
    const index=settingsViewList?.findIndex(item=>item?.ViewID==settingsView?.ViewID) || 0;
      try{
       
        const data = {
          ViewID:settingsView.ViewID,
          ViewName:saveAsNameText,
          UserID:settingsView.UserName,
          IsShared:renamedIsShared,
          IsDateOrderDesc:settingsView.IsDateOrderDesc,
          IsDefault:renamedIsDefault
        };
        await sbaAxios({
          url:renameView,
          data:data,
          method:'post'
        });
        toast.success('View renamed successfully.')
      }
      catch(e){
        toast.error('Unable to rename');
      }
      finally{
        setRenameModalShow(false);
        fetchViews(index);
      }
  };

  return (
    <>
      <TopBar label={"Portfolio Attribution"} />
      <div className="mainContentData">
        <BreadCrumbs Levels={Level} />
        <div className="p-3">
          <div className="detail p-3">
            <div className="row mb-2">
              <div className="col-md-2 d-flex" onClick={() => {
                setDrawer(!drawer);
              }}>
                <button

                  className="p-sm-btn px-2"
                >
                  <img
                    style={{ transform: `${drawer ? 'rotate(0deg)' : 'rotate(180deg)'}`, transition: 'transform 0.3s' }}
                    src="/images/collapse_side_bar_right-1.svg"
                  ></img>
                </button>
                {!drawer ? <label className="label mx-2 d-flex align-items-center opacity-75">Expand Search</label> : <label className="label mx-2 d-flex align-items-center opacity-75">Collapse  Search</label>}
              </div>
            </div>
            <div className="row">
              <div className="d-flex gap-2">
                {drawer && <div className="detail p-2" style={{ minWidth: '400px', maxWidth: '400px' }}><TreeViewComponent
                  familyList={familyList}
                  setClientStatements={setClientStatements}
                  setFamilyList={setFamilyList}
                  familyListBackUP={familyListBackUP}
                  setFamilyListBackUP={setFamilyListBackUP}
                  selectedPortfolio={selectedPortfolio}
                  setSelectedPortfolio={setSelectedPortfolio} /></div>}
                <div style={{ flexGrow: 1 }}>
                  <div className="row mb-2" >
                    <div className="col-md-2">
                      <div className="w-100">
                        <label className="mb-1 label">
                          Select Date Range
                        </label>
                        <SBDateRangePicker
                          value={dateRange}
                          onChange={(e) => { handleDateChange(e) }}
                        />
                      </div>
                    </div>
                    <div className="col-2">
                      <label className="mb-1 label">Report Classification</label>

                      <SBAComboBox
                        className="w-100"
                        data={Classificationdata}
                        value={selectedReportClassification}
                        textField={"ReportClassification"}
                        valueField={"ReportClassificationId"}
                        onChange={(e) => {setselectedReportClassification(e.value) }}
                        popupSettings={{ className: "modalDD" }}
                        placeholder="Please Select"
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="mb-1 label">Views</label>
                      <SBAComboBox
                        data={viewDatas}
                        onChange={(e) => { setViewdata(e.value); setSettingsView(e.value) }}
                        textField={"ViewName"}
                        valueField={"ViewID"}
                        value={Viewdata}
                      />
                    </div>

                    <div className="col-md-3 d-flex gap-2 row-items">
                      <span className="d-block mx-1" style={{ whiteSpace: "nowrap" }}>
                        <input type="checkbox" checked={isHideZero} onChange={() => { setIsHideZero(value => !value) }} /> Hide Zero
                      </span>
                      {/* <span className="d-block mx-1" style={{ whiteSpace: "nowrap" }}>
                        <input type="checkbox" /> Look Through
                      </span> */}
                      <span className="d-block mx-1" style={{ whiteSpace: "nowrap" }}>
                        {/* <input type="checkbox" checked={isHideBench} onChange={() => { setIsHideBench(value => !value) }} /> Hide Benchmarks */}
                      </span>
                      <span className="d-block mx-1" style={{ whiteSpace: "nowrap" }}>
                        {/* <input type="checkbox" checked={isHideFee} onChange={() => { setIsHideFee(value => !value) }} /> Hide Fees */}
                      </span>
                    </div>
                    <div className="col-md-3 d-flex gap-2 row-items justify-content-end">
                      <div
                        style={{ flexGrow: 1 }}
                        className="d-flex  justify-content-end gap-2"
                      >
                        <button
                          class="p-sm-btn mx-1"
                          disabled={!isEdit}
                          onClick={(e) => { getGridData() }}
                        >
                          Enter
                        </button>
                        <button
                          class="p-sm-btn mx-1"
                          disabled={!isEdit}
                          onClick={() => {
                            if (gridRef.current) {
                              gridRef.current.AttributionExcelExport();
                            }
                          }}
                        >
                          <img src="/images/download.svg" alt="" />
                          Export
                        </button>
                        <i className="fa-solid fa-file p-2" onClick={()=> OpenDocumentsDrawer()}></i>
                        <i className="fa-solid fa-gear  p-2" onClick={() => OpenCustomWindow()}></i>

                      </div>
                    </div>
                  </div>
                  <div>
                    <AttributionContainer selectedPortfolio={selectedPortfolio} dateRange={dateRange} viewType={Viewdata} isDataLoading={isDataLoading} ref={gridRef} hideZero={isHideZero} hideFee={isHideFee} hideBench={isHideBench} colDef={colDef} gridData={gridData} />
                  </div>
                </div>
              </div>
              {/* View Settings Column ----- */}
              <SBADrawer
                open={showView}
                setOpen={setshowView}
                close={false}
                title={"Custom View"}
                style={{ width: "70vw" }}
              >
                <div className="drawer">
                  <div className="row">
                    <div className="col-md-4 gap-2" >
                      <label className="header-container m-1">
                        <b>Views:</b>
                      </label>
                      <div>
                        <SBADropDown
                          className="w-200"
                          textField={"ViewName"}
                          valueField={"ViewID"}
                          data={settingsViewList}
                          value={settingsView}
                          popupSettings={{ className: "modalDD" }}
                          onChange={(e) => setSettingsView(e.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 d-flex gap-4 row-items">
                      <i
                        className="fas fa-edit"
                        style={{ color: "#47A547", margin: "0 8px", cursor: "pointer", height: "20px" }}
                        onClick={() => {
                          setRenameModalShow(true);
                          setSaveAsNameText(settingsView.ViewName);
                          setRenamedIsShared(settingsView.IsShared);
                          setRenamedIsDateDesc(settingsView.IsDefault);
                          setRenamedIsDefault(settingsView.IsDefault);
                        }}
                      ></i>
                      <i
                        className="fas fa-trash"
                        style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer", height: "20px" }}
                        onClick={() => setDeleteModalShow(true)}
                      ></i>
                      <span className="d-block mx-1" style={{ whiteSpace: "nowrap" }}>
                        <input type="checkbox" disabled={settingsView?.UserID==0}  checked={settingsView?.IsShared} onClick={() =>setSettingsView(val=>({...val,IsShared:!val.IsShared}))} /> Shared
                      </span>
                      <span className="d-block mx-1" style={{ whiteSpace: "nowrap" }}>
                        <input type="checkbox" checked={settingsView?.IsDateOrderDesc} onClick={() => setSettingsView(val=>({...val,IsDateOrderDesc:!val.IsDateOrderDesc}))} /> Date Order Descending
                      </span>
                      {
                        list_Attributes.length==0 &&  <span className="d-block mx-1" style={{ whiteSpace: "nowrap" }}>
                        <input type="checkbox" checked={settingsView?.ShowValuation} onClick={() => setSettingsView(val=>({...val,ShowValuation:!val.ShowValuation}))} /> Show Valuation Status
                      </span>
                      }
                     
                    </div>
                  </div>
                  <div className="row mt-4" >

                    <div className="col-md-4" >
                      <div>
                        <label className="header-container m-1">
                          <b>Available Statistics:</b>
                        </label>
                        <div>
                          <SBADropDown
                            className="w-200"
                            textField={"EnumName"}
                            valueField={"EnumValue"}
                            data={availableStatistics}
                            value={selectedAvailableStatistics}
                            popupSettings={{ className: "modalDD" }}
                            onChange={(e) =>
                              setSelectedAvailableStatistics(e.value)}
                          />

                        </div>
                      </div>
                      <div className="row" style={{ marginBottom: "10px" }}>
                        <div className="col-md-6">
                          <label className="header-container m-1">
                            <b>Date Options:</b>
                          </label>
                          <div>
                            <SBADropDown
                             disabled={showDateOptions}
                              className="w-200"
                              textField={"EnumName"}
                              valueField={"EnumValue"}
                              data={availableDateOptions}
                              value={selectedAvailableDateOptions}
                              popupSettings={{ className: "modalDD" }}
                              onChange={(e) => setSelectedAvailableDateOptions(e.value)}
                            />
                          </div>

                        </div>
                        <div className="col-md-6">

                          {!showDateOptions && <div className="col-md-6">


                            {selectedAvailableDateOptions?.EnumValue == 5 && <>  <label className="header-container m-1">
                              <b>Year:</b>
                            </label><div>
                                <input type="number"
                                  className="form-control"
                                  value={nYearsBack}
                                  onChange={(e) => {
                                    const number = parseInt(e.target.value);
                                    setNYearsback(number)
                                  }
                                  }
                                />
                              </div>  </>}
                            {selectedAvailableDateOptions?.EnumValue == 6 && <>  <label className="header-container m-1">
                              <b>Year:</b>
                            </label>  <div>
                                <input type="number"
                                  className="form-control"
                                  value={lastNYearsBack}
                                  onChange={(e) => {
                                    const number = parseInt(e.target.value);
                                    setLastNYearsBack(number)
                                  }}
                                />
                              </div></>}
                            {selectedAvailableDateOptions?.EnumValue == 7 && <>  <label className="header-container m-1">
                              <b>Year:</b>
                            </label>  <div>
                                <SBADropDown
                                  className="w-200"
                                  textField={"EnumName"}
                                  valueField={"EnumValue"}
                                  data={calendarYearsData}
                                  value={CalendarYears}
                                  popupSettings={{ className: "modalDD" }}
                                  onChange={(e) => setCalendarYears(e.value)}
                                />
                              </div></>}
                            {selectedAvailableDateOptions?.EnumValue == 8 && <>  <label className="header-container m-1">
                              <b>Value:</b>
                            </label>  <div>
                                <SBADropDown
                                  className="w-200"
                                  textField={"EnumName"}
                                  valueField={"EnumValue"}
                                  data={nNumbersdata}
                                  value={NPeriods}
                                  popupSettings={{ className: "modalDD" }}
                                  onChange={(e) => setNPeriods(e.value)}
                                />
                              </div></>}

                          </div>}


                        </div>

                      </div>
                      <div>

                      </div>
                      <div className='gridDiv' >
                        <div className='d-flex justify-content-between'><label>Selected Statistics</label> <i className="fa fa-add SBA_hand" onClick={addStatistics} ></i></div>
                        <div className="griddata ag-theme-alpine" style={{ height: '20rem', width: 'auto' }}>
                          <AgGridReact
                            columnDefs={statisticsColumnDefs}
                            rowData={list_Statistics}
                            rowSelection={'single'}
                            defaultColDef={defaultColDef}
                            onGridReady={onStatisticsGridReady}
                            onRowDoubleClicked={(e)=>{setSettingsView(val=>({...val,AttrStatisticsItem:[...val.AttrStatisticsItem.filter(item=>(item?.ListType === "S")).filter(item=>(item.KeyName!=e.data.KeyName)),...val.AttrStatisticsItem.filter(item=>(item?.ListType === "A"))]}));}}
                            >
                          </AgGridReact>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 d-flex flex-column" >

                      <label className="header-container m-1">
                        <b>Repeated Attributes:</b>
                      </label>
                      <div style={{ marginBottom: "10px" }}>
                        <SBADropDown
                          className="w-200"
                          textField={"EnumName"}
                          valueField={"EnumValue"}
                          data={availbleAttributes}
                          value={selectedAvailableAttributes}
                          popupSettings={{ className: "modalDD" }}
                          onChange={(e) => setSelectedAvailableAttributes(e.value)}
                        />
                      </div>
                      <div>
                      </div>

                      <div className='gridDiv mt-auto' >
                        <div className='d-flex justify-content-between'><div>Repeated Attributes</div>  <i className="fa fa-add SBA_hand" onClick={addAttribute}></i></div>
                        <div className="griddata ag-theme-alpine" style={{ height: '20rem', width: 'auto' }}>
                          <AgGridReact
                            columnDefs={attributeColumnDefs}
                            rowData={list_Attributes}
                            rowSelection={'single'}
                            defaultColDef={defaultColDef}
                            onGridReady={onAttributeGridReady}
                            onRowDoubleClicked={(e)=>{setSettingsView(val=>({...val,AttrStatisticsItem:[...val.AttrStatisticsItem.filter(item=>(item?.ListType === "A")).filter(item=>(item.KeyName!=e.data.KeyName)),...val.AttrStatisticsItem.filter(item=>(item?.ListType === "S"))]}));}}

                          >
                          </AgGridReact>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 d-flex flex-column" >
                      <div>
                        <label className="header-container m-1">
                          <b>Grouping</b>
                        </label>
                        <div style={{ marginBottom: "10px" }}>
                          <SBADropDown
                            className="w-300"
                            textField={"EnumName"}
                            valueField={"EnumValue"}
                            data={availableGrouping}
                            value={selectedAvailableGrouping}
                            popupSettings={{ className: "modalDD" }}
                            onChange={(e) => setSelectedAvailableGrouping(e.value)}
                            
                          />
                        </div>
                      </div>
                      <div>
                                  
                      </div>
                      <div className='gridDiv mt-auto' >
                        <div className='d-flex justify-content-between'><div>Selected Grouping</div>  <i className="fa fa-add SBA_hand" onClick={addGrouping}>
                        </i></div>
                        <div className="griddata ag-theme-alpine" style={{ height: '20rem', width: 'auto' }}>
                          <AgGridReact
                            columnDefs={groupingColumnDefs}
                            rowData={list_Grouping}
                            rowSelection={'single'}
                            defaultColDef={defaultColDef}
                            onGridReady={onGroupingGridReady}
                            onRowDoubleClicked={(e)=>{setSettingsView(val=>({...val,AttrGroupingItem:val.AttrGroupingItem.filter(item=>item.GroupItemName!=e.data.GroupItemName)}));}}

                          >
                          </AgGridReact>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div className="mt-4">
                    <button className="s-sm-btn mx-1" onClick={() => {
                      setshowView(false);
                    }}>
                      Cancel
                    </button>
                    <button
                      className="p-sm-btn mx-1"
                      onClick={() => {
                        setViewdata(settingsView);
                        setshowView(false);
                      }}
                    >
                      Ok
                    </button>
                    <button className="p-sm-btn mx-1" onClick={() => { saveSelectedView() }}>
                      Save
                    </button>
                    <button disable className="p-sm-btn mx-1" onClick={() => { setSaveAsNameModal(true) }}>
                      Save As
                    </button>
                  </div>
                </div>
              </SBADrawer>
              <SBADrawer
                open={showDocumentDrawer}
                setOpen={setShowDocumentDrawer}
                close={false}
                title={"Client Statement Documents"}
                style={{ width: "40vw" }}
              >
                <div className="drawer p-4 space-y-6">
                {managerStatementDocumentList.length === 0 ? (
                    <p className="text-gray-500">No documents found.</p>
                  ) : (
                    managerStatementDocumentList.map((client, index) => (
                      <div key={index} className="border-b pb-4">
                        <h3 className="text-lg font-semibold text-blue-700 mb-2">
                          {client.ClientStatementName}
                        </h3>
                        <ul className="list-disc list-inside space-y-1">
                          {client.docs.map((doc) => (
                            <li 
                            key={doc.DocumentId}
                            className="text-blue-600 hover:underline cursor-pointer"
                            onClick={() => reportdownload(doc.DocumentId)}>
                              {doc.DocumentName}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))
                  )}
                </div>
              </SBADrawer>
            </div>
          </div>
        </div>
      </div>
      {renameModalShow && (
        <Modal show={renameModalShow} onHide={() => setRenameModalShow(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Rename View</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <label className="form-label">
                View name:
              </label>
              <input
                type="text"
                className="form-control me-3"
                placeholder="Enter new name"
                value={saveAsNameText}
                onChange={(e)=>{setSaveAsNameText(e.target.value)}}
              />
              {/* First checkbox */}
              <div className="d-flex">
              <div className="form-check mt-3">
                <input
                  type="checkbox"
                  checked={renamedIsShared}
                  onClick={()=> setRenamedIsShared(!renamedIsShared)}
                  disabled={settingsView?.UserID==0} 
                />
                <label className="form-check-label mx-2" htmlFor="checkbox1" >
                  Shared
                </label>
              </div>
              {/* Second checkbox */}
              {/* <div className="form-check mt-3">
                <input
                  type="checkbox"
                  checked={renamedIsDateDesc}
                  onClick={()=> setRenamedIsDateDesc(!renamedIsDateDesc)}
                />
                <label className="form-check-label mx-2" htmlFor="checkbox2">
                  Date Descending
                </label>
              </div> */}
              {/* Third checkbox */}
              <div className="form-check mt-3">
                <input
                  type="checkbox"
                  checked={renamedIsDefault}
                  onClick={()=> setRenamedIsDefault(!renamedIsDefault)}
                />
                <label className="form-check-label mx-2" htmlFor="checkbox2">
                  Default
                </label>
              </div>
              </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="s-sm-btn mx-1" onClick={() => setRenameModalShow(false)}>
              Cancel
            </button>
            <button
              className="p-sm-btn mx-1"
              onClick={handleRenameView}
            >
              Confirm
            </button>
          </Modal.Footer>
        </Modal>
      )}
      {deleteModalShow && (
        <Modal show={deleteModalShow} onHide={() => setDeleteModalShow(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Delete View</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Do you really want to delete this view?</p>
          </Modal.Body>
          <Modal.Footer>
            <button className="s-sm-btn mx-1" onClick={() => setDeleteModalShow(false)}>
              Cancel
            </button>
            <button
              className="p-sm-btn mx-1"
              onClick={handleViewDelete}
            >
              Confirm
            </button>
          </Modal.Footer>
        </Modal>
      )}
       {saveAsNameModal && (
        <Modal show={saveAsNameModal} onHide={() => setSaveAsNameModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Save As</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <label className="form-label">
                View name:
              </label>
              <input type="text"  className="form-control"  value={saveAsNameText} onChange={(e)=>{setSaveAsNameText(e.target.value)}}/>
              <div className="d-flex">
              {/* First checkbox */}
              <div className="form-check mt-3">
                <input
                  type="checkbox"
                  checked={saveAsIsShared}
                  onClick={()=> setSaveAsIsShared(!saveAsIsShared)}
                />
                <label className="form-check-label mx-2" htmlFor="checkbox1" >
                  Shared
                </label>
              </div>
              {/* Second checkbox */}
              <div className="form-check mt-3">
                <input
                  type="checkbox"
                  checked={saveAsIsDefault}
                  onClick={()=> setSaveAsIsDefault(!saveAsIsDefault)}
                />
                <label className="form-check-label mx-2" htmlFor="checkbox2">
                  Default
                </label>
              </div>
              </div>

          </Modal.Body>
          <Modal.Footer>
            <button className="s-sm-btn mx-1" onClick={() => {setSaveAsNameModal(false);setSaveAsNameText("")}}>
              Cancel
            </button>
            <button
              className="p-sm-btn mx-1"
              onClick={createNewView}
            >
              Confirm
            </button>
          </Modal.Footer>
        </Modal>
      )}
      <ToastContainer />
    </>
  );
};
export const TreeViewComponent = ({ setClientStatements, familyList, setFamilyList, familyListBackUP, setFamilyListBackUP, selectedPortfolio, setSelectedPortfolio }) => {

  const getPortfolioByFamily = async (famID) => {
    try {
      const portfolios = await sbaAxios({ url: `${getPortfoliosByFamily}?familyId=${famID}` })
      return portfolios.map(portfolio => ({ ...portfolio, marked: true }))
    } catch {
      return []
    }
  };
  const getPortfolioByCS = async (csID) => {
    try {
      const portfolios = await sbaAxios({ url: `${getPortfolioByClientStmt}${csID}` })
      return portfolios.map(portfolio => ({ ...portfolio, marked: true }))
    } catch {
      return []
    }
  };

  const clientStatementIdsExtractor = (e) => {
    const CSIds = [];
    if (e?.item?.items) {
      e.item.items.forEach(obj => CSIds.push({"csID":obj.ClientStatementId, "csName":obj.ClientStatementName}));
    } else if (e?.item?.ClientStatementId) {
      CSIds.push({"csID":e.item.ClientStatementId, "csName":e.item.ClientStatementName});
    }
  
    setClientStatements(prev => {
      if (e.item.checked) {
        // Remove items with matching csID
        return prev.filter(existing =>
          !CSIds.some(toRemove => toRemove.csID === existing.csID)
        );
      } else {
        // Add items, avoiding duplicates based on csID
        const merged = [...prev];
        CSIds.forEach(newItem => {
          if (!merged.some(existing => existing.csID === newItem.csID)) {
            merged.push(newItem);
          }
        });
        return merged;
      }
    });
  };

  const afterCheck = (e) => {
    clientStatementIdsExtractor(e);
    let localFamilyList = [];
    let localFamilybackUpList = [];
    if (e.item.type === 'family') {
      localFamilyList = familyList.map(item => {
        if (item.FamilyId === e.item.FamilyId) {
          const previousCheck = e.item.checked;
          const clientStatements=e?.item?.ClientStatements || [];
          const csIDs=clientStatements.map(item=>item.ClientStatementId);
          if (!previousCheck) { 
            // clientStatements.forEach(async(element) => {
            //   await addPortfolioByCS(element.ClientStatementId);
            // });
            addPortfolioByCSIds(csIDs);
          }
          else {
            // clientStatements.forEach(async(element) => {
            //   await removePortfolioByCS(element.ClientStatementId);
            // });
            removePortfolioByCSIds(csIDs);
          }
          const SubItems = e?.item?.items?.map(cs => {
            if (true) {
              // if (!previousCheck) {
              //   addPortfolioByCS(cs.ClientStatementId);
              // }
              // else {
              //   removePortfolioByCS(cs.ClientStatementId);
              // }
              return { ...cs, checked: !previousCheck }
            }
           
          })

          return { ...item, checked: !previousCheck, items: SubItems }
        }
        else 
        return item
      });
      localFamilybackUpList = familyListBackUP.map(item => {
        if (item.FamilyId === e.item.FamilyId) {
          const previousCheck = e.item.checked;
          const clientStatements=e?.item?.ClientStatements || [];
          if (!previousCheck) {
            // clientStatements.forEach(element => {
            //   addPortfolioByCS(element.ClientStatementId);
            // });
          }
          else {
            // clientStatements.forEach(element => {
            //   removePortfolioByCS(element.ClientStatementId);
            // });
          }
          const SubItems = e?.item?.items?.map(cs => {
            // if (cs.ClientStatementId === e.item.ClientStatementId) {
            //   if (!previousCheck) {
            //     // addPortfolioByCS(e.item.ClientStatementId);
            //   }
            //   else {
            //     // removePortfolioByCS(e.item.ClientStatementId);
            //   }
            // }
            // else 
            // return { ...cs }
            return { ...cs, checked: !previousCheck }
          })
          return { ...item, checked: !previousCheck, items: SubItems }
        }
        else 
        return item
      });

    }


    else if (e.item.type === 'clientStatement') {
      localFamilyList = familyList.map(item => {
        if (item.FamilyId === e.item.FamilyId) {
          const previousCheck = e.item.checked;
          const updatedCS=item.items.map(cs => {
              
            if (cs.ClientStatementId === e.item.ClientStatementId) {
              if (!previousCheck) {
                addPortfolioByCS(e.item.ClientStatementId);
              }
              else {
                removePortfolioByCS(e.item.ClientStatementId);
              }
              return { ...cs, checked: !previousCheck }
            }
            else 
            return { ...cs }
          })
          return {
            ...item, items:updatedCS , checked:updatedCS.some(item=>item.checked)
          }
        }
        else return item
      });
      localFamilybackUpList = familyListBackUP.map(item => {
        if (item.FamilyId === e.item.FamilyId) {
          const previousCheck = e.item.checked;
          const updatedCS=item.items.map(cs => {
              
            if (cs.ClientStatementId === e.item.ClientStatementId) {
              if (!previousCheck) {
                // addPortfolioByCS(e.item.ClientStatementId);
              }
              else {
                // removePortfolioByCS(e.item.ClientStatementId);
              }
              return { ...cs, checked: !previousCheck }
            }
            else 
            return { ...cs }
          })
          return {
            ...item, items:updatedCS , checked:updatedCS.some(item=>item.checked)
          }
        }
        else return item
      });
    }

    //   localFamilyList=localFamilyList.map(fam=>{
    //   if(fam.FamilyId===e.item.FamilyId)
    //     {
    //      const uncheckedCS= fam.items.filter(cs=>!cs.checked);
    //       if(uncheckedCS.length==0)
    //       return {...fam,checked:true};
    //       else
    //       return {...fam,checked:false};
    //     }
    //   else return fam
    // });
    setFamilyList(localFamilyList);
    setFamilyListBackUP(localFamilybackUpList);
  };
  const afterExpand = (e) => {
    setFamilyList(fl => (fl.map(item => {
      if (item.FamilyId === e.item.FamilyId) {
        return { ...item, expanded: !e.item.expanded }
      }
      else return { ...item, expanded: false }
    })))
    setFamilyListBackUP(fl => (fl.map(item => {
      if (item.FamilyId === e.item.FamilyId) {
        return { ...item, expanded: !e.item.expanded }
      }
      else return { ...item, expanded: false }
    })))
  };
  const addPortfolioByFamily = async (familyId) => {
    const newData = await getPortfolioByFamily(familyId);
    setSelectedPortfolio(value => getUniquePortfolios([...value, ...newData]));
  };
  const removePortfolioByFamily = async (familyId) => {
    const familyPortfolio = await getPortfolioByFamily(familyId);
    const updatedPortfolio = selectedPortfolio.filter(port => !familyPortfolio.some(someItems => port.FamilyId === someItems.FamilyId))
    setSelectedPortfolio(updatedPortfolio);
    // setSelectedPortfolio(removerFromSelectedPortfolio());
  };
  const addPortfolioByCS = async (CSID) => {
    const newData = await getPortfolioByCS(CSID)
    // const formattedData={...newData,EntityId:newData.PortfolioId,EntityName:newData.PortfolioName}

    setSelectedPortfolio(value => getUniquePortfolios([...value, ...newData]));
  };
  const addPortfolioByCSIds = async (CSIDs) => {
    const portfolioArrays = await Promise.all(CSIDs.map(CSID => getPortfolioByCS(CSID)));
    const portfolios = portfolioArrays.flat();
    setSelectedPortfolio(value => getUniquePortfolios([...value, ...portfolios]));
  };
  function getUniquePortfolios(arr) {
    const uniqueValuesMap = {};
    const uniqueValues = [];

    arr.forEach(obj => {
      if (!uniqueValuesMap[obj.PortfolioName]) {
        uniqueValuesMap[obj.PortfolioName] = true;
        uniqueValues.push(obj);
      }
    });

    return uniqueValues;
  };
  const removePortfolioByCS = async (CSID) => {
    const CSIDPortfolios = await getPortfolioByCS(CSID);
    const updatedPortfolio = selectedPortfolio.filter(port => !CSIDPortfolios.some(someItems => port.ClientStatementId === someItems.ClientStatementId))
    setSelectedPortfolio(updatedPortfolio);
    // setSelectedPortfolio(portfolioList=>(portfolioList.filter(portfolio=>portfolio.)))
    // setSelectedPortfolio(removerFromSelectedPortfolio(await getPortfolioByCS(CSID)));
  };
  const removePortfolioByCSIds = async (CSIDs) => {
    const portfolioArrays  = await Promise.all(CSIDs.map(CSID => getPortfolioByCS(CSID)));
    const portfolios = portfolioArrays.flat();
    setSelectedPortfolio(value =>
      value.filter(port => !portfolios.some(item => port.ClientStatementId === item.ClientStatementId))
    );
  };
  
  const removerFromSelectedPortfolio = (portfolioList) => {
    const updatedList = selectedPortfolio.filter(item => !portfolioList.some(portfolio => item.EntityId === portfolio.EntityId))
    return updatedList;
  };
  const filterFamilyList = (e) => {
    const text = e?.target?.value || "";
    if (text.length > 0) {
      setFamilyList(familyListBackUP.filter(item => (item.FamilyName.toLowerCase().includes(text.toLowerCase()))))
    }
    else {
      setFamilyList(familyListBackUP);
    }
  };
  const updatePortfolio = (e, index) => {
 
    if (e.ctrlKey) {
      const newPortfolio = [...selectedPortfolio];
      newPortfolio[index] = { ...newPortfolio[index], marked: !newPortfolio[index].marked };
      setSelectedPortfolio(newPortfolio);
    } else {
      const modifiedList = selectedPortfolio.map((obj, i) => ({ ...obj, marked: i === index }));
      setSelectedPortfolio(modifiedList);
    }
  };
  return (
    <>
      <div>
        <label className="mb-1 label">Portfolio Search</label>
        <input
          className="form-control"
          type="text"
          // value={filteredValue}
          onChange={(e) => { filterFamilyList(e) }}
        />
      </div>
      <div>
        <label className="mb-1 label"> Portfolio Group</label>
        <div
          className="detail p-2"
          style={{ height: '37vh', overflowY: 'scroll' }}
        >
          <SBTreeView
            data={familyList}
            expandIcons={true}
            onExpandChange={(e) => { afterExpand(e) }}
            aria-multiselectable={true}
            onItemClick={(e) => {}}
            checkboxes={true}
            onCheckChange={(e) => { afterCheck(e) }} />
        </div>
      </div>
      <div className="py-2" style={{ width: '100%' }}>
        <label className="mb-1 label">Selected Portfolio</label>
        <div className="detail py-3" style={{ height: "25vh", overflowY: "scroll" }}>
          {selectedPortfolio.length === 0 ? (
            <div className="p-1 m-1"
              style={{
                textAlign: 'center',
              }}>No data available</div>
          ) : (
            selectedPortfolio.map((item, index) => (
              <div
                key={index}
                className="p-1 m-1"
                style={{
                  backgroundColor: item?.marked ? item?.IsPartnership ? "#4c7a9fcc" :'#354f65' : '#fff',
                  border: '2px solid #354f65',
                  color: item?.marked ? '#fff' : '#000',
                  textAlign: 'left',
                  cursor: 'pointer',
                }}
                onClick={(e) => { updatePortfolio(e, index) }}
              >
                {item.PortfolioName}
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};
export const AttributionContainer = forwardRef(({ selectedReportClassification,dateRange, viewType, hideZero, hideFee, hideBench, colDef, gridData, isDataLoading, selectedPortfolio }, ref) => {
  const [formattedGridData, setFormattedGridData] = useState([]);
  const [gridLoader, setgridLoader] = useState(isDataLoading);
  const gridRef = useRef();
  useEffect(() => {
    if (gridRef.current)
      if (gridLoader)
        gridRef.current?.api?.showLoadingOverlay();
    // else 
    // ref.current?.api?.hideLoadingOverlay();
  }, [gridLoader]);
  const resizeAllColumns = () => {
    if (gridRef?.current) {
      const allColumns = gridRef.current.columnApi.getAllColumns();
      gridRef.current.columnApi.autoSizeColumns(allColumns.map(col => col.getColId()));
    }
  };
  useImperativeHandle(ref, () => ({
    AttributionExcelExport,
  }));

  const AttributionExcelExport = () => {
    // exportToExcelUsingRef(gridRef,'Portfolio Attribution')
    attributionExport();
  }


  useEffect(() => {
    setgridLoader(isDataLoading);
  }, [isDataLoading]);
  useEffect(() => {
    let data = gridData;
    const regexPattern = /BMV|EMV/;
    if (hideZero) {
      data = data.filter(item => {
        const keys = Object.keys(item);
        const hasValidBMVAndEMV = keys.some(key => regexPattern.test(key) && item[key] && parseInt(item[key]) !== 0);
        return hasValidBMVAndEMV;
      });
    }
    if (hideFee)
      data = data.filter(item => !item?.IsFeesLine);
    if (hideBench)
      data = data.filter(item => !item?.IsIndexLine);
    const feeLine = data.filter(item => item?.IsFeesLine);
    const totalLines = data.filter(item => (
      item.AssetName === "Invested Performing Total" ||
      item.AssetName === "Total Assets Excluded from Performance" ||
      item.AssetName === "Total Portfolio"));
    data = [...data.filter((item, index, self) => {
      if (item.SecurityName.length === 3) {
        const StrategyName = item?.SecurityName[1];
        const count = self.filter(dataItem => dataItem?.SecurityName[1] === StrategyName && dataItem.IsAdvised === item.IsAdvised);
        return count.length > 1;
      }
      else
        return true;

    })].filter(item => !item.IsFeesLine).filter(item => !(
      item.AssetName === "Invested Performing Total" ||
      item.AssetName === "Total Assets Excluded from Performance" ||
      item.AssetName === "Total Portfolio"));
    setFormattedGridData(val => [...data.sort((a, b) => a.SortOrder - b.SortOrder).sort((a, b) => {
      if (a?.IsIndexLine) return 1;
      if (b?.IsIndexLine) return -1;
      return 0;
    }), ...feeLine, ...totalLines]);
  }, [gridData, hideZero, hideFee, hideBench]);

  const autoGroupColumnDef = useMemo(() => {
    return {
      headerName: "Security",
      minWidth: 475,
      pinned: "left",
      cellRendererParams: {
        suppressCount: true,
        innerRenderer: SecurityCellRenderer
      },
      editable: false,
      headerClass: "ag-grid-BR",
      valueFormatter: securityFormatter,
      useValueFormatterForExport: true,
      // tooltipValueGetter: (p) => p.data,
      // enableBrowserTooltips: true,
      // tooltipComponent: ToolTip,
      // tooltipHideDelay: 500,
      // tooltipInteraction: true,
      // cellRenderer:SecurityCellRenderer
    };
  }, []);


  const getDataPath = useMemo(() => {
    return (data) => {
      return data?.SecurityName;
    };
  }, []);
  const gridOptions = {
    groupDefaultExpanded: -1,
  };
  const autoSizeStrategy = {
    type: 'fitCellContents'
  };
  const moveToNextGroup = (value) => {
    const element = document.getElementsByClassName('ag-center-cols-viewport')?.[0];
    if (element) {
      element.scrollLeft += value;
    }
  };
  const showScroller = colDef.some(item => item?.children?.length > 0);
  const getContextMenuItems = useCallback(
    (params) => {
      let result = []

      if (params?.node?.data?.exportTimeSeries)
        result = [
          {
            name: "Export Time Series",
            action: async () => {
 
              const selectedEntity = params.node.data;
              const selectedPortfolioIDs = selectedEntity.selectedPortfolios
                .map(item => item.PortfolioId)
                .join(",") || "";

              let asset = "NAN";
              if (selectedEntity?.type === "security") {
                asset = selectedEntity?.AssetName;
              } else if (selectedEntity?.LevelName) {
                asset = selectedEntity?.LevelName;
              }

              let assetId = 0;
              if (selectedEntity?.type === "security") {
                assetId = selectedEntity?.AssetId;
              } else if (selectedEntity?.FundId) {
                assetId = selectedEntity?.FundId;
              }
              let portfolioId = 0;
              if (selectedEntity?.type === "security") {
                portfolioId = selectedEntity?.PortfolioId;
              } else if (selectedEntity.selectedPortfolios[0]) {
                portfolioId = selectedEntity.selectedPortfolios[0]?.EntityId || 0
              }

              const data = {
                "type": selectedEntity.type,
                "asset": asset,
                "assetId": assetId,
                "portfolioId": portfolioId,
                "breakPeriod": 0,
                "levelCategory": selectedEntity?.LevelCategory || 0,
                "levelId": selectedEntity?.LevelId || 0,
                "addHistory": selectedEntity?.AddHistory,
                "endDate": dateRange.end.toISOString(),
                "levelIdentifier": selectedEntity?.LevelIdentifier?.join(',') || "",
                "isPartnership": selectedEntity?.IsPartnerEntity || false,
                "partnershipID": 0,
                "portfolioIDs": selectedPortfolioIDs,
              };
              const timeSeriesData = await sbaAxios({ url:  addQueryString(exportTimeSeriesAPI,"ReportClassificationId",selectedReportClassification?.ReportClassificationId || null), method: 'post', data });
              const formattedTimeSeriesData = timeSeriesData.map(item => ({
                ReportDate: moment(item.ReportDate).format('MM/DD/YYYY'),
                RoR: item.RoR
              }));

              exportToExcel(formattedTimeSeriesData, `${asset}-Time series export.xlsx`)

            },
          }
        ];

      return result;
    },
    [window],
  );
  const excelStyles = [
    {
      id: "Currency",
      dataType: "number",
      numberFormat: {
        format: '"$"#,##0.00',
      },
    },
    {
      id: "Percentage",
      dataType: "number",
      numberFormat: {
        format: "0.00%",
      },
    },
    {
      id: "noneFormat",
      // font: { color: "#FFFFFF"},
      // text:"-",
      // value:"-",
      cell: {
        value: '-',
        text: "-"
      }
    },

  ];
  const attributionExport = () => {
    gridRef.current.api.exportDataAsExcel({
      fileName: 'portfolio-Attribution.xlsx',
      processCellCallback: (params) => {
        let value = params.value;
        const colId = params.column?.colDef?.cellClass || "";
        if (colId === "noneFormat") {
          value = parseFloat(value);
          if (value === null || value === undefined || value === 0) {
            return '-';
          }
        }
        params.cellClass = colId;
        return value;
      },
    });
  };

  return (
    <div className="py-2 ">
      {showScroller && <div className="d-flex justify-content-end gap-2 position-relative" >
        <button className="SBA_hand" style={{ position: 'absolute', left: '92%', top: '24px', zIndex: '1' }} onClick={() => { moveToNextGroup(-500) }}><i class="fa-solid fa-arrow-left"></i></button>
        <button className="SBA_hand" style={{ position: 'absolute', left: '95%', top: '24px', zIndex: '1' }} onClick={() => { moveToNextGroup(500) }}><i class="fa-solid fa-arrow-right"></i></button>
      </div>}
      <div className="ag-theme-alpine" style={{ height: "67vh" }}>
        <AgGridReact
          ref={gridRef}
          columnDefs={colDef}
          rowData={formattedGridData}
          autoGroupColumnDef={autoGroupColumnDef}
          getDataPath={getDataPath}
          treeData={true}
          // onRowDataUpdated={()=>{
          //   gridRef.current.columnApi.autoSizeAllColumns(true);
          // }}
          // onFirstDataRendered={()=>{
          //   resizeAllColumns()
          // }}
          // isRowMaster={isRowMaster}
          // onGridReady={onGridReady}
          getContextMenuItems={getContextMenuItems}
          autoSizeStrategy={autoSizeStrategy}
          defaultColDef={defaultColumnDef}
          gridOptions={gridOptions}
          excelStyles={excelStyles}
          // defaultExcelExportParams={defaultExcelExportParams}
          getRowClass={(e) => { if (e?.data?.IsFeesLine || e?.data?.IsIndexLine) { return "sbGridParentRow" } }}
          overlayLoadingTemplate={gridLoader && '<div class="Loader"><div id="loading"><div><span style="--i: 1;"></span><span style="--i: 2;"></span><span style="--i: 3;"></span><span style="--i: 4;"></span><span style="--i: 5;"></span><span style="--i: 6;"></span><span style="--i: 7;"></span><span style="--i: 8;"></span><span style="--i: 9;"></span><span style="--i: 10;"></span></div></div></div>'}
        ></AgGridReact>
      </div>
      {viewType?.ShowValuation &&
        <div className="d-flex justify-content-end gap-2 position-relative">
          <div className="legend-container d-flex align-items-center gap-3 p-2 border rounded bg-light">
              <span className="legend-item d-flex align-items-center">
                  <span className="legend-box bg-success"></span> Actual (A)
              </span>
              <span className="legend-item d-flex align-items-center">
                  <span className="legend-box bg-primary"></span> Estimated (E)
              </span>
              <span className="legend-item d-flex align-items-center">
                  <span className="legend-box bg-danger"></span> Stale (S)
              </span>
          </div>
      </div>}

    </div>
  );
});
const defaultColumnDef = {
  flex: 1,
  minWidth: 100,
  resizable: true,
  enableValue: true,
  enableRowGroup: true,
  sortable: true,
  autoHeaderHeight: true
};
function getMonthsBetweenDates(startDate, endDate) {
  const months = [];
  let currentDate = new Date(endDate);
  currentDate.setDate(1);
  while (currentDate >= startDate) {
    months.push(currentDate.toLocaleString('default', { month: 'long', year: 'numeric' }));
    currentDate.setMonth(currentDate.getMonth() - 1);

  }

  return months;
};
function formatStats(value, KeyName, decimalLength = 2) {
  if (value == null || isNaN(value)) {
    return "";
  }
  if (parseFloat(value) == 0) {
    return "-"
  }

  switch (KeyName) {
    case "BMV":
    case "EMV":
    case "Transactions":
    case "IntraBuys":
    case "IntraSells":
    case "AttributionPnl":
    case "YtdPnl":
      value = formatCurrencyValue(value);
      break;

    case "Beg%":
    case "End%":
    case "QTD":
    case "ITD":
    case "AttributionPercent":
    case "RorReturn":
    case "YtdRor":
    case "QtdRor":
    case "ItdRor":
    case "ITDAnnRor":
    case "ItdAtt%":
    case "QtdAtt%":
    case "YtdAtt%":
    case "MTD":
    case "CompoundRORDaily":
    case "CumulativeRORDaily":
    case "CompoundROR":
    case "CumulativeROR":
    case "BegGrp%":
    case "EndGrp%":
    case "AttrGrp%":
    case "QtdAttrGrp%":
    case "YtdAttrGrp%":
    case "ItdAttrGrp%":
    case "IRR":
      value = percentageValueFormatter(value);
      break;
    
    case "InceptionDate":
      value = dateValueFormatter(value);
      break;

    default:
      if (typeof value === 'number') {
        value = value.toFixed(decimalLength);
      }
      break;
  }

  return value;
};
const percentageValueFormatter = (value) => {
  if (value) {  
    const roundedNumber = 
    //roundNumber(value,4) 
    (value * 100).toFixed(2);
    return `${roundedNumber} %`;
  } else {
    return '';  
  }
};


const percentageFormatter = (value) => {
  const roundedNumber = (value * 100).toFixed(2);
  return `${roundedNumber} %`;
};
const formatCurrencyValue = (value) => {
  if (value) {
    if (parseFloat(value).toFixed(2)==0.00)
    return "";
    if (value == 0)
      return '';
    const formattedValue = `$${Math.abs(value).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`
    const returnValue = value > 0 ? formattedValue : `-${formattedValue}`
    return returnValue;
  }
  else return '';
};

const getCustodianDetails=async(reportDate,portfolioList)=>{
  try {
    const url=getPortfolioCustodiansAccounts+"ReportDate="+reportDate+"&portfolioList="+portfolioList
     return await sbaAxios({url});
  } catch (error) {
    console.log('Error fecthing Custodian Details');
    return [];
  }
}
const SecurityCellRenderer = (param) => {
  const assetId = param?.data?.AssetId;
  const assetName = param?.data?.AssetName;
  const portfolioId = param?.data?.PortfolioId;
  const portfolioName = param?.data?.PortfolioName;
  const accountName = param?.data?.AccountName;
  const accountId = param?.data?.AccountId;
  const custodianName = param?.data?.CustodianName;
  const tooltip = (
    <Tooltip
    className="attribution-asset-tooltip"
    style={{ "--bs-tooltip-max-width": "100%" }} 
    >
      <div>
        {assetId && <div style={{display:'flex',gap:'8px'}}><b>Asset ID:</b> <span style={{fontWeight:400}}>{assetId}</span></div>}
        {accountId>0 && <div style={{display:'flex',gap:'8px'}}><b>Account Name:</b> <span style={{fontWeight:400}}>{accountName}</span></div>}
        {custodianName && <div style={{display:'flex',gap:'8px'}}><b>Custodian Name:</b><span style={{fontWeight:400}}> {custodianName}</span></div>}
      </div>
    </Tooltip>
  );

  return (
    <OverlayTrigger  placement="top" trigger={["hover", "focus"]} overlay={tooltip} delay={{ show: 0, hide: 0 }} >
      <a  onClick={(e) => e.preventDefault()} style={{ textDecoration: "none" }}>
        {securityFormatter(param)}
      </a>
    </OverlayTrigger>
  );
};



function securityFormatter(params) {
  const starIndex = params?.value?.indexOf('***');
  if (starIndex > 0)
    return params.value.slice(0, starIndex);
  else
    return params.value;
};
const exportToExcel = (jsonData, Filename) => {
  const ws = XLSX.utils.json_to_sheet(jsonData);
  const range = XLSX.utils.decode_range(ws['!ref']);

  const percentageColIndex = 1;
  const dateColIndex = 0;


  for (let row = range.s.r + 1; row <= range.e.r; row++) {
    const cell = ws[XLSX.utils.encode_cell({ r: row, c: percentageColIndex })];
    if (cell && typeof cell.v === 'number') {
      cell.z = '0.00%';
    }
  };

  for (let row = range.s.r + 1; row <= range.e.r; row++) {
    const cell = ws[XLSX.utils.encode_cell({ r: row, c: dateColIndex })];
    if (cell && cell.v instanceof Date) {
      cell.z = 'mm/dd/yyyy';
    }
  };
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  XLSX.writeFile(wb, Filename);
};


function GetExcelFormat(KeyName, decimalLength = 2) {
  let value = '';
  switch (KeyName) {
    case "BMV":
    case "EMV":
    case "Transactions":
    case "IntraBuys":
    case "IntraSells":
    case "AttributionPnl":
    case "YtdPnl":
      value = "Currency";
      break;

    case "Beg%":
    case "End%":
    case "QTD":
    case "ITD":
    case "AttributionPercent":
    case "RorReturn":
    case "YtdRor":
    case "QtdRor":
    case "ItdRor":
    case "ITDAnnRor":
    case "ItdAtt%":
    case "QtdAtt%":
    case "YtdAtt%":
    case "MTD":
    case "CompoundRORDaily":
    case "CumulativeRORDaily":
    case "CompoundROR":
    case "CumulativeROR":
    case "BegGrp%":
    case "EndGrp%":
    case "AttrGrp%":
    case "QtdAttrGrp%":
    case "YtdAttrGrp%":
    case "ItdAttrGrp%":
    case "IRR":
      value = "Percentage";
      break;

    case "InceptionDate":
      value = "";
      break;

    default:
      value = "";
      break;
  }

  return value;
};

function calSubtractMonths(n) {
  const newDate = new Date(); 
  newDate.setMonth(newDate.getMonth() - n);
  return newDate;
}


const dateValueFormatter=(val)=>{
  return val;
}

const addQueryString = (url, key, value) => {
  if (value != null && value !== '') {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  }
  return url;
};
